export const locale = {
    GENERAL: {
        NO_DATA: 'データがありません',
        CANCEL: 'キャンセル',
        CONFIRM: '確認',
        EDIT: '編集',
        ADD: '追加',
        COPY: 'コピー',
        COPIED: 'コピーしました',
        DELETE: '削除',
        SAVE: '保存',
        SHOW_CONTENT: '展開',
        HIDE_CONTENT: '折りたたみ',
        AUTH: 'このオブジェクトの内容を表示する権限がありません',
        DAY: '日',
        ALL: 'すべて',
        RELEASE: '公開',
        APPLY: '適用する',
        RESTART_EDITING: '編集を再開',
        CHANGE_OWNER: '所有者を変更',
        CHANGE_OWNER_2: 'カスタマーサポートを変更',
        CHANGE_OWNER_3: '作成者を変更',
        ADD_DEAL: '案件を追加',
        ADD_Case: 'ケースを追加',
        CLOSE: '閉じる',
        PIN: 'ピン留め',
        FIELDHISTORY: '変更履歴',
        NO_FIELDHISTORY: '変更履歴はまだありません',
        NO_EMAIL: 'メールはまだありません',
        NO_SMS: 'SMSはまだありません',
        ACTIVE: 'アクティブ',
        LOGOUT: 'ログアウト',
        SUCCESS: '成功',
        DASHBOARD: 'ダッシュボード',
        DATASHEET: 'データシート',
        NEXT: '次へ',
        PRE: '前へ',
        NONE: 'なし',
        MAIL: 'メール',
        LAST_NAME: '姓',
        FIRST_NAME: '名',
        SHORTCUTS: 'ショートカット',
        STATUS: 'ステータス設定',
        REFRESH: '更新',
        SETTING_BTN: 'データシート＆フィルター',
        PRODUCT: '製品',
        ACTIVITY: '活動',
        TO: '宛先',
        CC: 'CC',
        SENDER: '送信者',
        INCOMING: '受信',
        OUTGOING: '送信',
        RELOAD: '再読み込み',
        LOGOUT_MSG: 'ログアウトしてもよろしいですか？',
        SEARCH: '検索',
        UPDATE: '更新',
        SELECTALL: "すべて選択",
        KEEP_OLD_PASSWORD: "旧パスワードを使う",
        DONT_APPLY: "適用しない",
        SAVEANDRUN: "保存して生成する",
    },
    //------- Log in
    LOGIN: {
        MICROSOFT: 'Microsoftアカウントでサインイン',
        BACK_TO_LOGIN: 'アカウントでログイン',
        MICROSOFT_LOGIN_TITLE: 'Microsoftでサインイン',
        REFRESH: '再読み込み',
        HINT_1: 'Microsoftにログインしてください。',
        HINT_2: '更新して開始してください。',
        ACCOUNT: 'アカウント',
        PWD: 'パスワード',
        TENANT: 'テナント名',
        TRY: '無料トライアル',
        LOGIN: 'ログイン',
        LOGIN_2: 'UpDayにログイン',
        LOGIN_UPCHAT: 'UpChatにログイン',
        LOGIN_UPGPT: 'UpGPTにログイン',
        GET_VALI_CODE: '認証コードを取得',
        LOGIN_VALI_CODE: '認証コード',
        DESCRIPTION: 'すべての顧客情報を一括で簡単管理',
        PASSWORD: 'パスワードをお忘れですか',
        ERROR: 'アカウントとパスワードを入力してください',
        ERROR_2: 'テナント名を入力してください',
        ERROR_3: 'アカウントまたはパスワードが間違っています。もう一度お試しください',
        ERROR_3_VALI_CODE: 'アカウント、パスワード、または認証コードが間違っています。もう一度お試しください',
        ERROR_4: '認証コードを取得するにはアカウントを入力してください',
        ERROR_5: 'ログイン情報が正しくありません',
        SENT_VALI_CODE: '認証コードをメールに送信しました',
        LOGIN_VAL_ERROR: '認証コードを送信できませんでした。詳しくはシステム管理者にお問い合わせください',
    },
    UPGPT_LOGIN: {
        TITLE: 'おかえりなさい！',
        SUBTITLE_1: '準備はできましたか？',
        SUBTITLE_2: 'UpGPTとの素晴らしい対話を始めましょう！',
        LOGIN: 'ログイン',
        DISCLAIMER: '免責事項',
        TERMSOFUSE: '利用規約',
        PRIVACYPOLICY: 'プライバシーポリシー',
        CHANGE_PASSWORD_ALERT: 'アカウントの安全を確保するために、初期パスワードの変更をおすすめします。',
    },
    FORGET_PASSWORD: {
        TITLE: 'パスワードをお忘れですか',
        TENANT: 'テナント名',
        ACCOUNT: 'アカウント',
        MAIL: 'Eメール',
        ERROR: '入力内容に誤りがあります。ご確認のうえ、再度お試しください。',
        AIRGAPPED: 'パスワードのリセットは管理者にお問い合わせください。',
    },
    TRY_IT_FREE: {
        TITLE: 'UpDayを14日間無料でお試し',
        FIRST_NAME: '*名',
        LAST_NAME: '*姓',
        ORG_NAME: '会社名',
        ROLE: '役職',
        PHONE: '連絡先電話番号',
        MESSAGE: 'メッセージ',
        MESSAGE_2: 'お申し込みありがとうございます。追ってご連絡いたします。',
        ERROR: '有効なメールアドレスを入力してください',
    },
    //------- Bower Title
    Bower_Title: {
        UPCHAT: 'Upday CIC - 顧客インタラクションセンター',
        Oppty_Dashboard: '商談ダッシュボード - UpDay',
        Case_Dashboard: 'サポート案件ダッシュボード - UpDay',
        Activity: '活動',
        Oppty_List: '商談一覧',
        Oppty: '商談',
        Deal: '商談',
        Contacts_List: '連絡先一覧',
        Contact: '連絡先',
        Company_List: '会社一覧',
        Company: '会社',
        Account: '会社',
        Campaign_List: 'キャンペーン一覧 - UpDay',
        Campaign: 'マーケティングキャンペーン',
        Segment_List: 'セグメント一覧 - UpDay',
        Segment: 'セグメント',
        Case_List: '案件一覧',
        Case: '案件',
        Order_List: '注文一覧',
        WIADVANCE_Order_List: '契約一覧',
        Order: '注文',
        WIADVANCE_Order: '契約',
        KnowledgeArticle_List: 'ナレッジ記事一覧 - UpDay',
        KnowledgeArticle: 'ナレッジ記事',
        Setting: '設定 - UpDay',
        Login: 'UpDayにログイン',
        LoginUpGPT: 'UpGPTにログイン',
        ResetPasswordogin: 'パスワードをリセット - UpDay',
        PermissionError: '権限がありません - UpDay',
        PermissionError_PAGE: 'このオブジェクトを表示する権限がありません',
        Portal_PermissionError_PAGE: '現在、UpGPTポータルを利用する権限がありません。システム管理者にお問い合わせください。',
        PageNotFoundError: 'このオブジェクトは存在しません - UpDay',
        PageNotFoundError_PAGE: 'このオブジェクトは存在しません。前のページに戻ってください。',
    },
    //---------Rule
    RULE: {
        RULE_R_NUM: 'この項目は必須です。数字を入力してください',
        RULE_R_NUM_2: '17桁以内の数字を入力してください（小数点以下2桁まで可）',
        RULE_R_NUM_3: '小数点以下2桁の数字を入力してください',
        RULE_R_NUM_4: '17桁以内の数字を入力してください',
        RULE_R_NUM_5: '正の数を入力してください',
        RULE_R_NUM_6: '1〜2の整数を入力してください',
        RULE_R_NUM_7: '数字または小数を入力してください',
        RULE_R_NUM_8: '正の整数を入力してください',
        RULE_NUM: '数字を入力してください',
        RULE_R: 'この項目は必須です',
        RULE_R_LASTNAME: '連絡先の姓は必須です',
        RULE_R_LASTNAME_2: '姓は必須です',
        RULE_R_LASTNAME_3: 'ユーザーの姓は必須です',
        RULE_R_FIRSTNAME: '名は必須です',
        RULE_R_COMPANY_NAME: '会社名は必須です',
        RULE_R_OPPTY_NAME: '商談名は必須です',
        RULE_R_OPPTY_Contact: '顧客名は必須です',
        RULE_R_Case_Contact: '顧客名は必須です',
        RULE_R_TEMPLATE_NAME: 'テンプレート名は必須です',
        RULE_R_Case: '案件名は必須です',
        RULE_R_SEGMENT: 'セグメント名は必須です',
        RULE_R_CAMPAIGN: 'キャンペーン名は必須です',
        RULE_R_ACCOUNT: '連絡先アカウントは必須です',
        RULE_R_PROCESS: 'プロセス名は必須です',
        RULE_R_STAGE: 'ステージ名は必須です',
        RULE_R_TITLE: 'タイトルは必須です',
        RULE_R_NAME: '名前は必須です',
        RULE_R_ADDRESS: '住所は必須です',
        RULE_HTTP: 'http:// または https:// で始めてください',
        RULE_URL: '正しいURL形式を入力してください',
        RULE_EMAIL: '正しいEメール形式を入力してください',
        RULE_PHONE: '正しい電話番号形式を入力してください',
        RULE_PHOTO: '画像ファイルをアップロードしてください',
        RULE_CSV: 'CSVファイルをアップロードしてください',
        RULE_FILE: '添付ファイルの合計サイズは20MB以内にしてください',
        RULE_FILE_2: '画像サイズは1MB未満にしてください',
        RULE_FILE_3: 'ファイルサイズは{size}MB未満にしてください',
        RULE_FILE_4: '画像サイズは20MB未満にしてください',
        RULE_FILE_5: 'ファイルの合計数は3を超えることはできません',
        RULE_DUE_DATE: '予定完了日は必須です',
        RULE_PROCCESS: '取引プロセスの選択が必要です',
        RULE_FORECAST: '予測カテゴリの選択が必要です',
        RULE_REASON: '失敗理由の選択が必要です',
        RULE_NOTE: '備考は必須です',
        RULE_NOTE_1000: '備考は1000文字以内にしてください',
        RULE_DATE: '正しい日付形式（YYYY-MM-DD）を入力してください',
        RULE_DATETIME: '正しい日付時間形式（YYYY-MM-DD HH:mm）を入力してください',
        RULE_5: '5文字以内で入力してください',
        RULE_9: '9文字以内で入力してください',
        RULE_10: '10文字以内で入力してください',
        RULE_16: '16文字以内で入力してください',
        RULE_17: '17文字以内で入力してください',
        RULE_20: '20文字以内で入力してください',
        RULE_30: '30文字以内で入力してください',
        RULE_50: '50文字以内で入力してください',
        RULE_10_50: '10〜50文字以内で入力してください',
        RULE_60: '60文字以内で入力してください',
        RULE_70: '70文字以内で入力してください',
        RULE_86: '86文字以内で入力してください',
        RULE_90: '90文字以内で入力してください',
        RULE_100: '100文字以内で入力してください',
        RULE_200: '200文字以内で入力してください',
        RULE_250: '250文字以内で入力してください',
        RULE_300: '300文字以内で入力してください',
        RULE_500: '500文字以内で入力してください',
        RULE_1000: '1000文字以内で入力してください',
        RULE_10000: '10000文字以内で入力してください',
        RULE_NULL: '文字を入力してください',
        RULE_HHMM: '形式はHH:MMで入力してください',
        RULE_PROGRESS: '0〜100の値を入力してください',
        RULE_CF_1: '選択肢が重複しています',
        RULE_CF_2: '選択肢に「,」は含めないでください',
        RULE_ALPHA_NUMERIC: '英字、数字、またはアンダースコアのみを入力してください',
        NO_SPECIAL_SYMBOL: '中国語/英語の文字、数字、アンダースコア、または空白を入力してください。',
        RULE_LOWER_ALPHA_NUMERIC: '小文字の英語、数字、またはアンダースコアを入力してください',
    },
    BREADCRUMBS: {
        Contacts: '連絡先',
        Companies: '会社',
        Deals: '商談',
        Case: 'サポート案件',
        Campaign: 'マーケティングキャンペーン',
        Segment: '顧客セグメント',
        KnowledgeArticles: 'ナレッジ記事',
        Order: '注文',
        WIADVANCE_Order: '契約',
    },
    //-----DASHBOARD
    DASHBOARD: {
        TITLE: '商談ダッシュボード',
        EXPECTED_REVENUE: '予想売上',
        SUCCESSFULLY_CLOSED: '成功クローズ',
        CURRENT_PERIOD: '当期決算',
        EMAIL_PERFORMANCE: 'メールパフォーマンス',
        STAGE_AMOUNT: '各ステージの金額',
        SALES_RANKING: '販売ランキング',
        LATEST_OPPTY: '最新商談',
        WITHIN_30_DAYS: '30日以内',
        BEST_OPPTY: 'ベスト商談',
        TOP_5: 'トップ5',
        TODAY: '今日',
        THIS_YEAR: '今年',
        THIS_SEASON: '今期',
        THIS_MONTH: '今月',
        THIS_WEEK: '今週',
        SELECT_DATE: '日付選択',
        // ----ヘッダー
        OPPTY_OWNER: '商談担当者',
        CONTACT_NAME: '顧客名',
        OPPTY_NAME: '商談名',
        CURRENT_STAGE: '現在のステージ',
        CREATED_TIME: '作成日時',
        AMOUNT: '金額',
        EXPECTED_CLOSE_DATE: '予定クローズ日',
        THIS_PERIOD: '当期',
        PREVIOUS: '前期',
        DIFFERENCE: '差異',
        QUANTITY_SENT: '送信数',
        READ: '開封数',
        CLICKED: 'リンククリック数',
        UNKNOWN: '不明',
        GO_OPPTY: '商談へ移動',
    },
    //------- CONTACT
    CONTACT: {
        TITLE: '連絡先',
        BULK: '一斉配信',
        SEGMENT: '顧客セグメント作成',
        EMAIL_PUSH: 'メール一斉送信',
        SMS_PUSH: 'SMS一斉送信',
        WIADVANCE_REPEAT_EMAIL: '警告：重複したメールアドレスです。更新してよければ、このウィンドウを閉じて続行してください。',
        WIADVANCE_WRONG_CUSTOMER_CODE: '対応する会社に顧客コードがありません、またはBCに対応会社がありません。',
        WIADVANCE_CREATE_CONTACT_FAIL: 'BC同期に失敗しました。元のデータに戻します。',
        MESSAGE_DELETE: 'この連絡先を削除してもよろしいですか？',
        MESSAGE_FIRST: '先に削除してください',
        MESSAGE_OPPTY: '関連商談',
        MESSAGE_OPPTY_2: '関連商談',
        MESSAGE_CASE: '関連案件',
        MESSAGE_CASE_2: '関連案件',
        MESSAGE_ALL: '関連する商談または案件を先に削除してください',
        MESSAGE_ERROR: 'この連絡先には進行中の商談があります。担当者を変更してから削除してください。',
    },
    ADDSTATICSEGMENT: {
        TITLE: '静的顧客セグメントの新規作成',
        NAME: '顧客セグメント名',
    },
    CONTACT_DETAIL: {
        TITLE: '役職',
        ORG_NAME: '会社名',
        OWNER: '連絡先の所有者',
        CONTACT_INFORMATION: '連絡先情報',
        FIRST_NAME: '名',
        LAST_NAME: '姓',
        MOBILE_PHONE: '携帯電話',
        OFFICE_PHONE: '電話番号',
        BIRTHDAY: '誕生日',
        ADDRESS: '住所',
        SUB_ADDRESS: '住所2',
        CITY: '市区町村',
        COUNTRY: '国',
        LEVEL: 'レベル',
        ZIP_CODE: '郵便番号',
        DEPARTMENT: '部署',
        PROVINCE: '都道府県',
        RELATED_CAMPAIGN: '関連キャンペーン',
        DESCRIPTION: '説明',
        COMPANY_INFORMATION: '会社情報',
        ADD_COMPANY_INFORMATION: '会社情報を追加',
        NO_COMPANY_INFORMATION: '会社情報なし',
        COMPANY_NAME: '会社名',
        JURISTIC_PERSON_NAME: '法人名',
        POSITION: '役職',
        SHAREHOLDING: '持株比率',
        FAX: 'FAX',
        ENG_FIRST_NAME: '(英) 名',
        ENG_LAST_NAME: '(英) 姓',
        ENG_TITLE: '(英) 役職',
        ENG_DEPARTMENT: '(英) 部署',
        INVOICE_RECIEVED: '請求書受取',
        MAILING_ADDRESS: '住所2',
        //----NOTE
        ADD_NOTE: '備考を追加',
        NO_NOTE: '備考なし',
        //----Oppyt
        NO_DEAL: '商談なし',
        //----Timeline 
        TIMELINE: 'タイムライン',
        NO_TIMELINE: 'タイムラインなし',
        TIMELINE_TITLE: '役職が変更されました',
        TIMELINE_DEPARTMENT: '部署が変更されました',
        TIMELINE_LEVEL: 'レベルが変更されました',
        TIMELINE_OWNER: '連絡先所有者が変更されました',
        //----TAB
        DETAIL: '詳細情報',
        NOTE: '備考',
        EMAIL: 'メール',
        SMS: 'SMS',
        UPCHAT: '履歴メッセージ',
        ALL_OPPORTUNITIES: 'すべての商談',
        ALL_CASES: 'すべての案件',
        DEAL: '商談名',
        STAGE: '現在のステージ',
        //----MESSAGE
        MESSAGE: 'この備考を削除してもよろしいですか？',
        MESSAGE_2: 'この商談を削除してもよろしいですか？',
        MESSAGE_3: 'この連絡先を削除してもよろしいですか？',
        MESSAGE_4: 'この連絡先をコピーしてもよろしいですか？',
        MESSAGE_5: 'この連絡先の会社情報を削除してもよろしいですか？',
        ERROR: '画像ファイルを選択してください',
        ERROR_2: '写真は5MB未満でアップロードしてください',
        ERROR_3: '正しい形式で入力してください',
        ERROR_4: '会社名を入力してください',
        ERROR_5: 'すでに同じ会社があります',
        ERROR_6_1: 'この連絡先は商談の',
        ERROR_6_2: '顧客です。顧客を再割り当てしてから削除してください',
        ERROR_7: 'この連絡先に関連する商談が進行中です。再割り当て後に削除してください',
        ERROR_8: 'この連絡先に会社情報がありません',
    },
    ADD_CONTACT: {
        TITLE: '新しい連絡先を追加',
        FIRST_NAME: '連絡先名',
        LAST_NAME: '連絡先姓',
        SELECT_LABEL: '地域',
        MOBILE_PHONE: '携帯電話',
        OFFICE_PHONE: 'オフィス電話',
        LEVEL: 'レベル',
        ORG_NAME: '会社名',
        IMAGE: '連絡先写真を更新',
        CN_TITLE: '役職',
        DEPARTMENT: '部署',
        ENG_FIRST_NAME: '(英) 連絡先名',
        ENG_LAST_NAME: '(英) 連絡先姓',
        ENG_TITLE: '(英) 役職',
        ENG_DEPARTMENT: '(英) 部署',
        INVOICE_RECIEVED: '請求書受取',
        MAILING_ADDRESS: '住所2',
    },
    EDIT_CONTACT: {
        TITLE: '連絡先を編集',
        FIRST_NAME: '連絡先名',
        LAST_NAME: '連絡先姓',
        SELECT_LABEL: '地域',
        MOBILE_PHONE: '携帯電話',
        OFFICE_PHONE: 'オフィス電話',
        LEVEL: 'レベル',
        ORG_NAME: '会社名',
        IMAGE: '連絡先写真を更新',
    },
    ADDCONTACTORG: {
        TITLE: '会社情報を追加',
        COMPANY_NAME: '会社名',
        JURISTIC_PERSON_NAME: '法人名',
        POSITION: '役職',
        SHAREHOLDING: '持株比率',
        ERROR: 'すでにこの会社が存在します',
    },
    //------- COMPANY
    COMPANY: {
        TITLE: '会社',
        VCF: 'VCF申請',
        //----MESSAGE
        MESSAGE: 'この会社を削除してもよろしいですか？',
        MESSAGE_2_1: 'まずは削除してください',
        MESSAGE_2_2: '関連する商機',
        MESSAGE_2_3: '関連する案件',
        MESSAGE_3: '関連する商機または案件を先に削除してください',
        WIADVANCE_REPEAT_CUSTOMERCODE: 'Customer Code は重複できません。既に作成された会社があるかご確認ください',
    },
    COMPANY_DETAIL: {
        PHONE: '電話番号',
        ADDRESS: '住所',
        SUB_ADDRESS: '住所2',
        WEB: 'ウェブサイト',
        OWNER: '所有者',
        INFO: '会社情報',
        NAME: '会社名',
        NAME_EN: '(英) 会社名',
        COMPANY_NUMBER: '統一番号',
        FAX: 'ファックス',
        TYPE: '種類',
        INDUSTRY: '業種',
        EMPLOYEE: '従業員数',
        ANNUAL_REVENUE: '営業額',
        REGISTERED_CAPITAL: '資本金',
        ESTABLISH_DATE: '設立日',
        RELATED_CAMPAIGN: '関連キャンペーン',
        DESCRIPTION: '説明',
        CITY: '市区町村',
        COUNTRY: '国',
        LEVEL: 'レベル',
        ZIP_CODE: '郵便番号',
        PROVINCE: '都道府県',
        CLOSING_DATE: '締日',
        PAYMENT_TERM: '支払条件',
        REGULAR_PAYMENT_DATE: '固定支払日',
        BELONG_GROUP: '所属グループ',
        //----NOTE
        ADD_NOTE: '新規メモ追加',
        NO_NOTE: 'メモなし',
        //----Oppyt
        NO_DEAL: '商談なし',
        STAGE: '現在のステージ',
        //----primary contact
        CONTACT: '主な連絡先',
        NO_CONTACT: '主な連絡先なし',
        //----Timeline 
        TIMELINE: 'タイムライン',
        NO_TIMELINE: 'タイムラインなし',
        TIMELINE_EMPLOYEE: '従業員数が変更されました',
        TIMELINE_REVENUE: '年間営業額が $ に変更されました',
        TIMELINE_CAPITAL: '資本金が $ に変更されました',
        TIMELINE_OWNER: '連絡先所有者が変更されました',
        TIMELINE_PEOPLE: '人',
        //----TAB
        DETAIL: '詳細',
        NOTE: 'メモ',
        ALL_OPPORTUNITIES: 'すべての商談',
        ALL_CASES: 'すべての案件',
        DEAL: '商談名',
        //----MESSAGE
        MESSAGE: 'このメモを削除してもよろしいですか？',
        MESSAGE_2: 'この商談を削除してもよろしいですか？',
        MESSAGE_3: 'この会社を削除してもよろしいですか？',
        ERROR: '画像ファイルを選択してください',
        ERROR_2: '写真は5MB以下にしてください',
    },
    ADD_COMPANY: {
        TITLE: '会社追加',
        ORG_NAME: '会社名',
        TYPE: '種類',
        INDUSTRY: '業種',
        IMAGE: '顧客ロゴアップロード',
        WEB: 'ウェブサイト',
        PHONE: '電話番号',
        FAX: 'ファックス',
        ADDRESS: '住所',
        EMPLOYEE: '従業員数',
        COMPANY_NUMBER: '統一番号',
        COUNTRY: '国',
        ZIP_CODE: '郵便番号',
        CITY: '市区町村',
        PAYMENT_TERM: '支払条件',
    },
    Edit_COMPANY: {
        TITLE: '会社編集',
        ORG_NAME: '会社名',
        TYPE: '種類',
        INDUSTRY: '業種',
        IMAGE: '顧客ロゴアップロード',
        WEB: 'ウェブサイト',
        PHONE: '電話番号',
        FAX: 'ファックス',
        ADDRESS: '住所',
        EMPLOYEE: '従業員数',
    },
    ADDMAINCONTACT: {
        TITLE: '会社連絡先の追加',
        TITLE_2: '会社連絡先の編集',
        NEW_CONTACT: '新しい連絡先を作成',
        OLD_CONTACT: '既存の連絡先を選択',
        CONTACT_NAME: '連絡先氏名',
        FIRST_NAME: '連絡先名',
        LAST_NAME: '連絡先姓',
        JURISTIC_PERSON_NAME: '法人名',
        POSITION: '役職',
        SHAREHOLDING: '持株',
        PRIMARY_CONTACT: '主要連絡先',
        ERROR: '新しい連絡先を追加する場合は、上部の「新しい連絡先を追加」ボタンをクリックしてください。追加の必要がない場合は、既存の連絡先を選択してください。',
    },
    MAINCONTACTS: {
        TITLE: '会社連絡先',
        PRIMARY: '主要',
        CONTACT_NAME: '連絡先氏名',
        JURISTIC_PERSON_NAME: '法人名',
        POSITION: '役職',
        SHAREHOLDING: '持株',
        PHONE: '電話',
        MAIL: 'メールアドレス',
        ACTIVE: '有効',
        MESSAGE: 'この連絡先を削除してもよろしいですか？',
    },
    //------- DEAL
    DEAL: {
        TITLE: '商機',
        OPPTIES: '商機',
        NO_DEAL: '商機なし',
        NO_DEAL_STAGE: '商業プロセスなし',
        PROCESS: '商業プロセス',
        //----MESSAGE
        MESSAGE: 'この商機を削除してもよろしいですか？',
        ERROR: '先に商業プロセスを作成してください',
        DELETE_ERROR: '以下の商機は既に完了しているため、削除できません。',
    },
    DEAL_DETAIL: {
        CHANGE_STAGE: '商業プロセスの変更',
        REOPEN: '商機を再開する',
        NAME: '商機名',
        EXPECTED_CLOSE_DATE: '予想終了日',
        CREATED_ON: '作成日',
        STATUS: 'ステータス',
        AMOUNT: '金額',
        SCORE: 'スコア',
        PROGRESS: '達成率',
        OWNER: '商機所有者',
        CLIENT_NAME: '顧客名',
        NEW_CLIENT: '新規顧客を作成',
        CONTACT: '主要連絡先',
        OPPTY_CONTACT: '商機連絡先',
        NO_OPPTY_CONTACT: '主要連絡先なし',
        CLIENT_BUDGET: '顧客予算',
        FORECAST_CATEGORY: '予測カテゴリ',
        RELATED_CAMPAIGN: '関連キャンペーン',
        CUSTOMER_NEEDS: '顧客ニーズ',
        PURCHASE_NEEDS_OR_PROCESS: '購買ニーズ／プロセス',
        EXPECT_OR_NEXTSTEPS_OR_OTHERS: '期待／次のステップ／その他',
        SALES_NOTES: '営業メモ',
        OPPTY_STATUS: '商機ステータス',
        INDUSTRY: '業種',
        CUSTOMER_SOURCE: '顧客ソース',
        OTHER_CUSTOMER_SOURCE: 'その他の顧客ソース',
        PROGRESS_2: '進捗',
        OPPTY_TYPE: '商機タイプ',
        SERIAL_NUMBER: '商機番号',
        ENDACCOUNT: 'エンド顧客',
        WIADVANCR_CUSTOMER_SOURCE: '商機の「顧客ソース」が「営業商機」の場合、Customer Codeは必須です。',
        //----Timeline
        TIMELINE: 'タイムライン',
        NO_TIMELINE: 'タイムラインがありません',
        NO_AMOUNT_CHANGE: '金額の変更はありません',
        NO_STAGE_CHANGE: 'ステージの変更はありません',
        NO_FIELD_CHANGE: 'その他の変更はありません',
        NO_ACTIVITY_CHANGE: '活動記録がありません',
        NO_MAIL: 'メールがありません',
        NO_SMS: 'SMSがありません',
        NO_NOTE: 'メモがありません',
        TIMELINE_AMOUNT: '商機の金額が $ に変更されました',
        TIMELINE_NAME: '商機名が変更されました',
        TIMELINE_FORECAST: '予測カテゴリが変更されました',
        TIMELINE_PROCESS: '商機プロセスが変更されました',
        TIMELINE_OWNER: '連絡先所有者が変更されました',
        TIMELINE_ECD: '商機の予想終了日が変更されました',
        SOON_DUE: 'まもなく期限が',
        SOON_DUE_1: '日後に到来します',
        SOON_DUE_2: '期限切れ（超過）',
        SOON_DUE_3: '日',
        SOON_DUE_4: '本日が期限です',
        //----TAB
        DETAIL: '詳細情報',
        NOTE: 'メモ',
        EMAIL: 'メール',
        SMS: 'SMS',
        ALL_CASES: 'すべての案件',
        //----timeLineType
        TIMELINE_TAB_ALL: 'すべて',
        TIMELINE_TAB_AMOUNT: '金額の変更',
        TIMELINE_TAB_STAGE: 'ステージの変更',
        TIMELINE_TAB_FIELD: 'その他の変更',
        TIMELINE_TAB_MAIL: 'メール',
        TIMELINE_TAB_SMS: 'SMS',
        TIMELINE_TAB_NOTE: 'メモ',
        //----MESSAGE
        MESSAGE: 'このメモを削除してもよろしいですか？',
        MESSAGE_2: 'この商機を削除してもよろしいですか？',
        MESSAGE_3: '終了日が上書きされます。再開しますか？',
    },
    ADD_DEAL: {
        TITLE: '商機の新規作成',
        NAME: '商機タイトル',
        ORG: '会社を選択',
        CONTACT: '連絡先を選択',
        NO_CONTACT: '連絡先名を入力して検索してください',
        NEW_CONTACT: '新しい連絡先を作成',
        OLD_CONTACT: '既存の連絡先を選択',
        AMOUNT: '商機金額',
        PROCESS: '商業プロセスを選択してください',
        EXPECTED_CLOSE_DATE: '予想終了日',
        FORCAST: '予測カテゴリ',
        DEAL_PROCESS: '商業プロセス',
        ERROR: '既に作成された取引プロセスを選択する必要があります',
        ERROR_2: '既存の連絡先を選択するか、新しい連絡先をクリックしてください',
        ERROR_3: '顧客または会社のいずれかを必ず入力してください',
    },
    TO_DEAL: {
        NAME: '顧客名',
        EXPECTED_CLOSE_DATE: '予想終了日',
        AMOUNT: '金額',
        SCORE: 'スコア',
        PROGRESS: '達成率',
        OWNER: '商機オーナー',
        INFO: '基本情報',
        GUIDE: '成功ガイド',
        BUDGET: '予算確認',
        PROBABILITY: '可能性',
        DESCRIPTION: '説明',
        DETAIL_PAGE: '詳細ページへ',
        IN: 'で',
        LOST: '失敗',
        CLOSED: 'クローズ',
        WIN: '成功クローズ',
        BECAUSE: '理由',
    },
    RELATEDCONTACTS: {
        TITLE: '連絡先',
        NEW_CONTACT: '新しい連絡先を作成',
        OLD_CONTACT: '既存の連絡先を選択',
        FIRST_NAME: '名前',
        LAST_NAME: '姓',
        NO_CONTACT: '連絡先の名前を入力して検索してください',
        ADD_CONTACT: '連絡先を追加',
        CONTACT_NAME: '連絡先名',
        ORG_NAME: '会社名',
        PHONE: '電話番号',
        MAIL: 'メールアドレス',
        ACTIVE: '有効',
        MESSAGE: 'この連絡先を削除してもよろしいですか？',
        ERROR: '新しい連絡先を追加する場合は、上の「新しい連絡先を作成」ボタンをクリックしてください。そうでなければ、既に作成された連絡先を選択してください。',
    },
    CHILD_CASE: {
        TITLE: 'サブケース',
        SUBJECT: '件名',
        CONTACT: '連絡先',
        PRIORITY: '優先度',
        STATUS: 'ステータス',
        GROUP: 'グループ',
        TYPE: 'タイプ',
        OWNER: '担当者',
        CLOSED_DATE: 'クローズ日',
        ACTIVE: '実行中',
        ADD_CHILD_CASE: 'サブケースを追加',
        NO_CHILD_CASE: '該当する検索結果がありません',
        SEARCH_CHILD_CASE: '案件タイトルを入力して検索してください',
        MESSAGE: 'このサブケースを削除してもよろしいですか？',
        ERROR: '既に作成された案件を選択してください',
    },
    EDITDEALDATE: {
        TITLE: '予想完了日の変更',
        NAME: '商機名',
        EXPECTED_CLOSE_DATE: '予想完了日',
    },
    //------- Case
    CASE: {
        TITLE: 'カスタマーサービス案件',
        CASE: '案件',
        NO_CASE: '案件がありません',
        NO_CASE_STAGE: '案件プロセスがありません',
        FINISH: '完了',
        CLOSED: 'クローズ',
        CASE_NUMBER: '案件番号',
        OWNER: 'カスタマーサービス担当者',
        //----MESSAGE
        MESSAGE: 'この案件を削除してもよろしいですか？',
        ERROR: '案件プロセスを先に作成してください',
        DELETE_ERROR: '以下の案件は既に完了しているため、削除できません。',
    },
    CASE_DETAIL: {
        CHANGE_STAGE: '案件プロセスの変更',
        CLOSED: '完了',
        REOPEN: '案件の再開',
        IN: 'にて',
        CONTACT: '主要担当者',
        PHONE: '受電電話',
        EMAIL: '受信メール',
        EMAIL_2: 'メール',
        EXPECTED_CLOSE_DATE: '予定完了日',
        CREATED_ON: '作成日',
        PRIORITY: '優先度',
        STATUS: '状態',
        OWNER: 'カスタマーサービス担当者',
        GUIDE: 'カスタマーサービスガイド',
        DAY: '日',
        CASE_NAME: '案件タイトル',
        CASE_NUMBER: '案件番号',
        ORG_NAME: '会社名',
        INCOMING_CONTACT: '受電担当者',
        SOURCE: '案件の発生元',
        GROUP: '案件グループ',
        TYPE: '案件タイプ',
        CASE_STATUS: '案件状態',
        RELATED_CAMPAIGN: '関連キャンペーン',
        DESCRIPTION: '案件説明',
        DESCRIPTION_2: '案件対応',
        PARENT_CASE: '親案件',
        //----TAB
        DETAIL: '詳細情報',
        NOTE: '備考',
        SMS: 'ショートメッセージ',
        PRO: '製品',
        RELATED_ARTICLE: '関連記事',
        ALL_ARTICLE: 'すべての記事',
        STAGE_CHANGE: 'ステージ変更',
        STATUS_CHANGE: '状態変更',
        FIELD_CHANGE: 'その他の変更',
        SUBJECT: '件名',
        CLOSED_DATE: '完了日',
        //----Timeline
        TIMELINE: 'タイムライン',
        NO_TIMELINE: 'タイムラインはありません',
        NO_STAGE_CHANGE: 'ステージ変更はありません',
        NO_STATUS_CHANGE: '状態変更はありません',
        NO_FIELD_CHANGE: 'その他の変更はありません',
        NO_NOTE: '備考はありません',
        NO_MAIL: 'メールはありません',
        NO_SMS: 'ショートメッセージはありません',
        ADD_NOTE: '備考を追加',
        ADD_PRO: '製品を追加',
        DEL_PRO: 'すべて削除',
        CASE_CLOSED: '案件はクローズされました',
        TIMELINE_OWNER: '担当者の所有権が変更されました',
        TIMELINE_NAME: '案件名が変更されました',
        TIMELINE_CONTACT: '主要担当者が変更されました',
        TIMELINE_STATUS: '案件状態が変更されました',
        TIMELINE_PRIORITY: '優先度が変更されました',
        TIMELINE_GROUP: '所属部署が変更されました',
        TIMELINE_TYPE: '案件タイプが変更されました',
        TIMELINE_DUE_DATE: '予定完了日が変更されました',
        TIMELINE_CASE_PROCESS: '案件処理プロセスが変更されました',
        //----Right
        PRIMARY_CONTACT_CASE: '主要担当者関連案件',
        NO_RELATED_CASE: '関連案件はありません',
        RELATED_CONTACT: '案件関連担当者',
        NO_RELATED_CONTACT: '関連担当者はいません',
        CHILD_CASE: '子案件',
        NO_CHILD_CASE: '関連子案件はありません',
        KNOWLEDGE_ARTICLE: '知識ベース記事',
        NO_RELATED_ARTICLE: '関連記事はありません',
        EXPAND: '展開',
        COLLAPSE: '折りたたみ',
        REMOVE: '削除',
        ADD: '追加',
        //----MESSAGE
        MESSAGE: 'この備考を削除してもよろしいですか？',
        MESSAGE_2: 'この案件を削除してもよろしいですか？',
        MESSAGE_3: '完了日は上書きされますが、それでも再開しますか？',
        MESSAGE_4: 'すべての子案件も一緒に完了しますか？',
        ERROR: '正しい形式を入力してください',
    },
    ADD_CASE: {
        TITLE: '案件の新規作成',
        NAME: '案件タイトル',
        ORG: '会社を選択',
        CONTACT: '担当者を選択',
        NO_CONTACT: '担当者名を入力して検索してください',
        NEW_CONTACT: '新しい担当者を作成',
        OLD_CONTACT: '既存の担当者を選択',
        PHONE: '受電電話',
        EMAIL: '受信メール',
        SOURCR: '案件の発生元',
        GROUP: '案件グループ',
        TYPE: '案件タイプ',
        PARENT_CASE: '親案件',
        CATEGORY: '案件分類',
        EXPECTED_CLOSE_DATE: '予定完了日',
        SELECT: '案件処理プロセスを選択してください',
        PROCESS: '案件プロセス',
        ERROR: '既存の取引プロセスを選択する必要があります',
        ERROR_2: '既存の担当者を選択するか、新しい担当者を作成してください',
        ERROR_3: '顧客または会社のどちらかを入力する必要があります',
        ERROR_4: '既存の案件を選択してください',
        USE_AUTONUMBER: '自動的に連番を入力する',
    },
    TO_CASE: {
        NAME: '顧客名',
        EXPECTED_CLOSE_DATE: '予定完了日',
        PRIORITY: '優先度',
        SCORE: 'スコア',
        STATUS: 'ステータス',
        OWNER: 'カスタマーサポート担当',
        GUIDE: 'カスタマーサポートガイド',
        BUDGET: '予算確認',
        DETAIL_PAGE: '詳細ページへ',
        IN: 'にて',
        LOST: '失敗',
        CLOSED: '完了',
        WIN: '成功完了',
        SOLVE: '解決済み',
    },
    ADD_CASE_PRODUCT: {
        TITLE: '製品リスト',
    },
    //------- Bulk Message
    Bulk_Message: {
        TITLE: 'プッシュ通知メッセージ',
    },
    //------- Segment
    SEGMENT: {
        TITLE: '顧客セグメント',
        //----MESSAGE
        MESSAGE: 'このセグメントを削除してもよろしいですか？',
        MESSAGE_2_1: 'まずは削除してください',
        MESSAGE_2_2: '関連するキャンペーン',
        MESSAGE_3: '関連キャンペーンを先に削除してください',
        //----head
        NAME: '顧客セグメント名',
        TYPE: 'セグメントタイプ',
        PEOPLE: 'セグメント人数',
        CAMPAIGNS: '関連マーケティングキャンペーン数',
        OWNER: '所有者',
        ACTIVE: '有効',
    },
    ACTIVITY: {
        ADD: '新しい活動を追加',
        TITLE: '活動',
        PRIORITY: '優先度',
        COMPLETED: '完了済み',
        MARK_COMPLETED: '完了としてマーク',
        REGARDING: '関連',
        TIME_FRAME: '期間',
        TYPE: '種類',
        OWNER: '担当者',
        SUBJECT: '件名',
        PROGRESS: '進捗',
        REMARK: '備考',
        CONTACT: '連絡先',
        ORG: '会社',
        URGENT: '緊急',
        IMPORTANT: '重要',
        MEDIUM: '普通',
        LOW: '低い',
        START_TIME: '開始時間',
        DUE_TIME: '期限',
        START_DAY: '開始日',
        END_DAY: '終了日',
        COMPLETED_UNCOMPLETED: '未完了',
        COMPLETED_COMPLETED: '完了',
        UNCOMPLETED_ACTIVITY: '未完了の活動',
        TYPE_SETTING: '活動タイプ設定',
        TYPE_NAME: 'タイプ名',
        TYPE_COLOR: '色',
        TYPE_ICON: 'アイコン',
        ADD_TYPE: '新しい活動タイプを追加',
        ADD_TYPE_BTN: 'タイプを追加',
        MESSAGE_DELETE: 'この活動を削除してもよろしいですか？',
        MONTH: '月',
        WEEK: '週',
        DAY: '日',
        TODAY: '今日',
        MORE: '{0} もっと見る',
        MONDAY: '月曜日',
        TUESDAY: '火曜日',
        WEDNESDAY: '水曜日',
        THURSDAY: '木曜日',
        FRIDAY: '金曜日',
        SATURDAY: '土曜日',
        SUNDAY: '日曜日',
        DELETE_ERROR: '以下の活動を削除する権限がありません:',
        NO_CONTACT: '連絡先が見つかりません',
        NO_ORG: '会社が見つかりません',
        NO_REGARDING: '案件または商機が見つかりません',
        WIADVANCE_NO_REGARDING: '商機が見つかりません',
        NOT_FOUND_404: '活動が存在しないか削除されました',
    },
    SEGMENT_DETAIL: {
        CONTACTS: '連絡先総数',
        CAMPAIGNS: '活動総数',
        TYPE: 'プッシュタイプ',
        OWNER: '顧客セグメント所有者',
        DESCRIPTION: 'セグメント説明',
        INFO: 'セグメント情報',
        NAME: '名前',
        RELATED_CAMPAIGN: '関連活動',
        TIME: '回',
        DELETE_CONTACT: '連絡先を削除',
        ADD_CONTACT: '連絡先を追加',
        CAMPAIGN_Analysis_Chart: 'キャンペーン分析チャート',
        NO_DATA: 'データなし',
        CAMPAIGN_Analysis_Statistics: 'キャンペーン分析統計',
        NO_CAMPAIGN_DATA: 'キャンペーンデータなし',
        //----TAB
        SETUP: '基本情報',
        CONTACT: '連絡先',
        ANALYSIS: '分析',
        C_NAME: '連絡先名',
        C_ORG: '会社名',
        C_PHONE: '連絡電話',
        C_MAIL: 'メール',
        C_AMOUNT: '合計金額',
        C_OWNER: '所有者',
        C_ACTIVE: '有効',
        CAM_NAME: 'マーケティングキャンペーン名',
        CAM_TYPE: '種類',
        CAM_TIME: '活動回数',
        S_V_S: '成功数 vs 送信数',
        O_V_S: '開封数 vs 成功数',
        C_V_S: 'クリック数 vs 成功数',
        S_V_O: '成功数 vs 開封数',
        S_V_C: '成功数 vs クリック数',
        SUCCESS: '成功数',
        SENT: '送信数',
        OPEN: '開封数',
        CLICK: 'クリック数',
        END_TIME: '最終送信時間',
        //----MESSAGE
        MESSAGE: 'このセグメントを削除してもよろしいですか？',
        MESSAGE_2: 'この連絡先を削除してもよろしいですか？',
        ERROR: '関連活動を先に削除してください',
    },
    ADD_SEGMENT: {
        TITLE: 'セグメントの追加',
        NAME: 'セグメント名',
        TYPE: 'セグメントタイプ',
        DESCRIPTION: '説明',
        MESSAGE: '新しいセグメントが作成されました。「確認」をクリックして表示します。',
    },
    EDIT_SEGMENT: {
        TITLE: 'セグメントの編集',
        NAME: 'セグメント名',
        TYPE: 'セグメントタイプ',
        DESCRIPTION: '説明',
    },
    ADDSEGMENTCONTACT: {
        TITLE: 'セグメントの連絡先',
        ADD_CONTACT: '連絡先の追加を確認',
        FIRST_NAME: '連絡先名',
        ORG_NAME: '会社名',
        PHONE: '電話番号',
        MAIL: 'メールアドレス',
    },
    //------- CAMPAIGN
    CAMPAIGN: {
        TITLE: 'マーケティングキャンペーン',
        //----MESSAGE
        MESSAGE: 'このマーケティングキャンペーンを削除してもよろしいですか？',
        MESSAGE_2: 'これらのマーケティングキャンペーンを削除してもよろしいですか？',
        ERROR: 'まずは顧客セグメントを作成してください',
        ERROR_2: 'このマーケティングキャンペーンは使用中です',
        ERROR_3: '以下のマーケティングキャンペーンは使用中です',
        //----head
        NAME: 'キャンペーン名',
        CHANNEL: '配信チャネル',
        SEGMENT: '顧客セグメント',
        PEOPLE: '参加者数',
        OWNER: '所有者',
        ACTIVE: '実行中',
    },
    CAMPAIGN_DETAIL: {
        STATUS: 'ステータス',
        CHANNEL: '配信チャネル',
        PEOPLE: '参加者数',
        SEGMENT: '顧客セグメント',
        OWNER: 'キャンペーン所有者',
        DESCRIPTION: 'キャンペーン説明',
        NAME: '名称',
        TYPE: 'キャンペーンカテゴリ',
        START_TIME: '開始日',
        END_TIME: '終了日',
        TEMPLATE: 'テンプレートを選択',
        EMAIL_CONTENT: 'メール内容：',
        SMS_CONTENT: 'SMS内容：',
        PREVIEW: 'プレビュー',
        SENTING: '送信中...',
        NO_O365: 'M365アカウントが未設定です。メールを送信するには、設定 > メール同期 > M365アカウント設定へ進んでください。ありがとうございます！',
        INVALID_O365_TOKEN: 'M365アカウントの設定が長期間使用されていません。設定 > メール同期で既存のM365アカウントを削除し、再設定してください。ありがとうございます！',
        GO_SETTING: '設定へ移動',
        SUBJECT: '件名',
        SMS_CONTENT_2: 'SMSメッセージ内容',
        CAMPAIGN_Analysis_Chart: 'キャンペーン分析チャート',
        NO_DATA: 'データなし',
        CAMPAIGN_Analysis_Statistics: 'キャンペーン分析統計',
        NO_CAMPAIGN_DATA: 'キャンペーンデータがありません',
        ATTACHMENT: '添付ファイル',
        //----TAB
        CAM_NAME: 'キャンペーン名',
        END_TIME_2: '最終送信時間',
        SETUP: '基本情報',
        ANALYSIS: '分析',
        //----MESSAGE
        MESSAGE: 'このマーケティングキャンペーンを削除してもよろしいですか？',
        ERROR: 'メールの件名を入力してください',
        ERROR_2: '内容を入力してください',
        ERROR_3: 'まず顧客セグメントで連絡先を追加してください。',
    },
    ADD_CAMPAIGN: {
        TITLE: 'マーケティングキャンペーンを追加',
        CHANNEL: '配信チャネル',
        NAME: 'キャンペーン名',
        SEGMENT: '顧客セグメント',
        DESCRIPTION: 'キャンペーンの説明',
    },
    EDIT_CAMPAIGN: {
        TITLE: 'マーケティングキャンペーンを編集',
        CHANNEL: '配信チャネル',
        NAME: 'キャンペーン名',
        SEGMENT: '顧客セグメント',
        DESCRIPTION: 'キャンペーンの説明',
    },
    CAMPAIGNCONTACTLIST: {
        TITLE: 'キャンペーン連絡先記録',
        ADD_SEG: '顧客セグメントを作成',
        Success: '送信成功',
        unSuccess: '送信失敗',
        Open: 'メール開封済み',
        unOpen: 'メール未開封',
        Link: 'リンククリック済み',
        unLink: 'リンク未クリック',
        CONTACT_NAME: '連絡先氏名',
        ORG_NAME: '会社名',
        PHONE: '電話番号',
        MAIL: 'メールアドレス',
    },
    //------- KnowledgeArticles
    KNOWLEDGE_ARTICLE: {
        TITLE: '知識ベース記事',
        MESSAGE: 'この記事を削除してもよろしいですか？',
        //----Headers
        H_TITLE: '記事タイトル',
        NUMBER: '知識ベース記事番号',
        STATUS: 'ステータス',
        UPDATED_ON: '最終更新日',
        AUTHOR: '作成者',
        ACTIVE: 'アクション',
    },
    KNOWLEDGE_ARTICLE_DETAIL: {
        NUMBER: '記事番号',
        SUBJECT: '記事のテーマ',
        STATUS: '記事のステータス',
        AUTHOR: '作成者',
        TITLE: 'タイトル',
        AUTONUMBER: '番号',
        SUBJECT_1: 'テーマ',
        STATUS_2: 'ステータス',
        KEYWORD: 'キーワード',
        DESCRIPTIONL: '説明',
        AUTONUMBER_1: '記事番号は自動生成されます',
        //-----BREADCRUMBS   
        KNOWLEDGEARTICLES: '知識ベース記事',
        ADD_KNOWLEDGEARTICLES: '知識ベース記事を追加',
        //----TAB
        DETAIL: '詳細',
        //----MESSAGE
        MESSAGE: 'この記事を削除してもよろしいですか？',
        MESSAGE_2: 'この記事を公開してもよろしいですか？',
        MESSAGE_3: 'この記事の編集を再開してもよろしいですか？',
        ERROR: '記事の内容を入力してください',
    },
    PREFERENCES: {
        PREFERENCE: "設定",
        ADD_PREFERENCE: "追加",
        TENANT: "テナント",
        CODE: "コード",
        VALUE: "値",
        NAME: "名称",
        DESCRIPTION: "説明",
        ACTIVE: "実行",
        MESSAGE: "この設定を削除してもよろしいですか？",
        ERROR: "このコードは既に存在します。",
        ERROR1: "：形式エラー、JSONではありません",
        RULE_UPPERCASE: "大文字英字またはアンダースコアである必要があります"
    },
    //------- Setting
    SETTING: {
        TITLE: '設定',
        PERSONALSETTING: '個人設定',
        PASSWORDANDLOGIN: 'ログインとセキュリティ',
        EMAILSYNC: 'メール同期',
        EMAILTEMPLATE: 'メール送信テンプレート',
        SMSTEMPLATE: 'SMS送信テンプレート',
        MANAGEUSERS: 'ユーザー管理',
        MANAGEGROUPS: 'チーム管理',
        CUSTOMFIELDS: 'カスタムフィールド',
        TABLESETTING: 'カスタムデータテーブル',
        FILTERSETTING: 'カスタムフィルター',
        PIPELINESTAGESETTING: '営業プロセス設定',
        CUSTOMERSERVICESETTING: 'カスタマーサービスオプション',
        KNOWLEDGEARTICLESUBJECTSETTING: '知識ベース記事のテーマ',
        AUTONUMBERSETTING: '連番設定',
        PRODUCTSETTING: '製品設定',
        NOTIFICATIONSETTING: "お知らせ設定",
        PERSONAL: "個人",
        COMMUNICATION: "コミュニケーション",
        COMPANY_SETTING: "会社設定",
        DATA_VIEW: "データ表示",
        CUSTOMER_SERVICE_SETTING: "カスタマーサービス設定",
        ACTIVITYTYPES: 'アクティビティ種別設定',
        SMSVENDOR: 'SMSプロバイダー設定',
        UPGPTSETTING: 'UpGPT設定',
        ASSISTANTSETTINGANDUPLOAD: 'AIロボット設定',
        GPTTOOLS: 'ツールボックス',
        UPLOADSTATUS: 'インポート/アップロード履歴',
        TREESETTING: 'ツリー選択肢設定',
        CALENDARSYNC: "カレンダー同期",
        CUSTOMOPPTYCLOSEDREASON: "カスタム商談終了理由",
    },
    CUSTOMOPPTYCLOSEDREASON: {
        ADD: "理由を追加",
        ADDREASON: "商談終了理由を追加",
        NAME: "終了理由",
        DESCRIPTION: "理由の説明",
        SELECTED: "有効化",
        ACTIVE: "実行",
    },
    TREESETTING: {
        ADD: '選択肢を追加',
        TS: 'ツリー選択肢',
        DEL_MSG: 'この選択肢を削除してもよろしいですか？',
        OPEN_ALL: 'すべて展開',
        CLOSE_ALL: 'すべて折りたたむ',
        NO_OPTION: '少なくとも1つの選択肢が必要です',
        ERROR: 'この選択肢名は既に存在します。',
        IS_USING: 'この選択肢は使用中のため削除できません',
        NO_DATA: 'まずツリー選択肢を追加してください',
    },
    UPGPT: {
        BASICSETTING: '基本設定',
        QAUPLOAD: 'Q&Aデータアップロード',
        FOLDERUPLOAD: 'フォルダアップロード',
        FILEUPLOAD: 'ファイルアップロード',
        UPLOADIMG: '画像アップロード',
        CLOUD: 'クラウドファイル',
        BASICSETTINGSAVE: '保存',
        AIASSISTANTNAME: 'AIロボット名',
        AIASSISTANTNAME_TIP1: 'AIロボットの名前を設定',
        AIASSISTANTNAME_TIP2: '例：アンちゃん',
        AIASSISTANTROLE: 'AIロボットの役割',
        AIASSISTANTROLE_TIP1: 'AIロボットの役割を設定',
        AIASSISTANTROLE_TIP2: '例：UpDay向けCRM製品のカスタマーサービス担当',
        TOPIC: 'トピック',
        TOPIC_TIP1: 'AIロボットが質問をより適切に変換できるようトピックを設定',
        TOPIC_TIP2: '例：UpDay CRM',
        TOPICLIMIT: 'トピック制限',
        TOPICLIMIT_TIP1: 'トピック外の質問には、AIロボットが設定されたトピックに沿って回答します',
        TOPICLIMIT_TIP2: '例：テクノロジー',
        RESETDATA: '既存知識のリセット',
        QAFILEUPLOADMESSAGE: 'Q&AファイルはCSV（UTF-8）形式である必要があります',
        FOLDERUPLOADMESSAGE: '圧縮ファイルのみ受け付けます',
        FILEUPLOADMESSAGE: 'txt、pdf、docx、pptxファイルのみ受け付けます',
        FILEUPLOADMESSAGE_IDP: 'pdf、docx、xlsx、pptxファイルのみ受け付けます',
        DELETEALLDATA: 'すべての既存情報をリセットしてもよろしいですか？',
        WRONGTYPEINZIP: '圧縮ファイル内にはtxt、CSV、pdf、docx、pptx、jpg、jpeg、pngファイルのみを含めてください',
        WRONGTYPEINCSV: 'Q&AファイルはCSV（UTF-8）形式である必要があります',
        WRONGTYPEINFILE: 'ファイルはtxt、pdf、docx、pptx形式のみ受け付けます',
        WRONGTYPEINFILE_IDP: 'ファイルはpdf、docx、xlsx、pptx形式のみ受け付けます',
        WRONGTYPEINIMAGEFILE: '画像ファイルはJPG、JPEG、PNG形式のみ受け付けます',
        WAIT: 'ファイルのアップロード完了後にもう一度お試しください',
        PREFERENCE_WRONG: '権限設定が不完全です。管理者に連絡してください',
        AIASSISTANT_KNOWLEDGE_MANAGEMENT: 'AIロボット知識管理',
        FILE_AMOUNT: 'ナレッジファイル総数：',
        UPDATE_TIME: '最終アップロード時間：',
        NOFILE: '知識ベースにファイルがありません',
        UPCHAT_INBOX_SETTING: 'UpChat受信箱設定',
        TIMEOUT_ERROR: 'データ量が多いため、AIロボットが知識ベースを整理中です。「インポート/アップロード履歴」で進捗を確認しますか？',
        TIMEOUT_ERROR_2: 'データ量が多いため、AIロボットが現在ナレッジベースに整理中です。処理中のファイルを確認しに行きますか？',
        EMBEDDING_WRONG: 'アップロード失敗。CSVファイルがUTF-8形式で、ヘッダーに二重引用符（"XXX"）が含まれていないことを確認し、暗号化されていないかご確認ください。再度アップロードを試し、それでも問題が解決しない場合は、UpDayサポートにご連絡ください。',
        UPLOAD_FAIL: 'アップロード失敗',
        FILE: 'ファイル',
        DOWNLOAD: 'ダウンロード',
        DOWNLOAD_TXT: 'テキストファイルをダウンロード',
        FILE_HAS_BEEN_DELETED: 'ファイルは削除されました。ページを更新してください',
        WEBSITEANALYSIS: 'ウェブサイト分析',
        WEBSITEANALYSIS_SYNC: 'ウェブサイト分析自動同期',
        WEBSITEANALYSIS_TIP1: '毎日深夜にスケジュール実行、第一階層のみ同期',
        ADD_URL: 'URLを追加',
        EDIT_URL: 'URLを編集',
        URL: 'URL',
        LEVEL: '深さ',
        OVERLIMIT: 'URLは最大5件まで登録可能',
        ACTION: '実行',
        DELETE_CHECK: 'このURLを削除してもよろしいですか？',
        START_ANALYSIS: '分析開始',
        DOWNLOAD_ZIP: '圧縮ファイルをダウンロード',
        BLANK_WEB_INFO: 'まず分析を実行してください。その後で結果をダウンロード可能になります',
        NO_URL: '少なくとも1つのURLを入力してください',
        FILE_TABLE: '連携済みナレッジファイル',
        NOT_CLEAN: '正しくクリアできませんでした。再度クリアを実行し、それでも問題が解決しない場合は、UpDayサポートにご連絡ください',
        AUTO_DETECT: '自動検出',
        REPLY_LANGUAGE: '返信言語',
        REPLY_LANGUAGE_TIP: 'AIロボットは選択された言語で回答します',
        TIMEOUT_MESSAGE: 'データ量が多いため、しばらくお待ちください。「進捗を見る」へ移動しますか？',
        OVER_SIZE: 'このフォルダ/ファイルをアップロードするとストレージ上限を超えます。support@upday.ai に連絡してストレージを追加購入するか、「連携済みナレッジファイル」からいくつか削除してください。',
        NOT_ENOUGH_QUOTA: 'スマートファイル分析の回数上限を超えました。support@upday.ai にご連絡ください。',
    },
    ACTIVITYTYPES: {
        ERROR: "この活動タイプは使用中のため削除できません。",
        ERROR_2: "少なくとも1つの活動タイプが必要です。",
        ERROR_3: "デフォルトの活動タイプは削除できません。"
    },
    SMSVENDOR: {
        VENDOR: "サービスプロバイダー",
        USER_NAME: "ユーザー名",
        USER_PWD: "ユーザーパスワード",
        DEFAULT: "デフォルト",
        MITAKE: "Mitake（三竹）",
        DOMAIN: "シングルSMS送信API URL",
        TIP: "Mitakeから提供されたAPIドキュメントを参照してください",
        TIP_2: "例 : https://smsapi.mitake.com.tw/api/mtk/SmSend?CharsetURL=UTF8"
    },
    PERSONALSETTING: {
        BOARD_CONTACT_SYNC: '経済部商業司からの取締役データを連絡先として同期する',
        FIRST_NAME: 'ユーザー名',
        LAST_NAME: 'ユーザー姓',
        LANGUAGE: '言語',
        CURRENCY: '通貨',
        REGION: '地域',
        OPPTY_DEFAULT_STAGE: '商談のデフォルトステージ',
        CASE_DEFAULT_STAGE: '案件のデフォルトステージ',
        INBOX_NOTIFICATION_SETTINGS: 'Inbox通知設定',
        ERROR: '画像ファイルを選択してください',
        ERROR_2: '画像は5MB未満である必要があります'
    },
    PASSWORDANDLOGIN: {
        TITLE: 'パスワード変更',
        TITLE_2: 'パスワードリセット',
        MESSAGE: 'アカウントの安全のため、定期的にパスワードを変更してください。複雑なパスワードを使用し、誕生日や電話番号など予測しやすい文字列は避けてください。',
        ERROR: 'パスワードは8～30文字で、大文字・小文字・数字・記号を含めてください',
        ERROR_2: '入力されたパスワードが一致しない、または形式が間違っています',
        ERROR_3: '現在のパスワードを入力してください',
        ERROR_4: '新しいパスワードと確認パスワードは必須です',
        ERROR_5: 'パスワードの入力を再確認してください',
        ERROR_6: 'パスワード変更に失敗しました。再試行してください',
        ERROR_7: '新しいパスワードと確認パスワードが一致しません。再入力してください',
        ERROR_8: 'パスワードリセットに失敗しました。再試行してください。原因:',
        ERROR_9: 'このパスワードリセットリンクは無効です',
        OLD_PASSWORD: '現在のパスワード',
        NEW_PASSWORD: '新しいパスワード',
        NEW_PASSWORD_2: '確認パスワード'
    },
    EMAILSYNC: {
        TEXT: 'アカウントをリンク',
        TEXT_2: '以下に接続済みのM365アカウントが表示されます',
        NO_CONNECT: 'リンクされたアカウントはありません',
        ADD_ACCOUNT: 'アカウントを追加',
        MESSAGE: 'このM365アカウント設定を削除してもよろしいですか？',
        ERROR: '削除に失敗しました。再試行してください',
        DIALOG: 'M365アカウントをリンク',
        DIALOG_2: '追加ボタンをクリックすると、M365ログインページにリダイレクトされます。成功するとこの設定ページに戻ります。',
        DIALOG_S: 'M365アカウントのリンク成功',
        DIALOG_S2: 'M365アカウントのリンクに成功しました。メール同期セクションでメールアドレスを確認してください。',
        START_SYNC: "同期開始",
        SYNCING: "同期中",
        H1: "メール同期オプション：",
        H1_1: "すべてのメールをUpDayに同期",
        H1_2: "指定したメールのみをUpDayに同期",
        H1_3: "オン",
        H1_4: "オフ",
        H2: "同期開始日：",
        H2_1: "今日",
        H2_2: "過去1ヶ月",
        H2_3: "過去3ヶ月",
        H2_4: "過去6ヶ月",
        H2_5: "カスタム",
        H3: "送信・受信メールの同期対象：",
        H3_1: "UpDayの連絡先のみ",
        H3_2: "すべての人",
        H4: "メール制限設定：",
        H5: "ブラックリストのメールまたはドメインを設定",
        H6: "ブラックリストメール",
        H7: "ブラックリストドメイン",
        H8: "許可ドメイン",
        TOO_MUCH_INBOX: "受信トレイ内のメールが9999件を超えています。より短い期間を選択して再試行してください。",
        TOO_MUCH_SENTBOX: "送信トレイ内のメールが9999件を超えています。より短い期間を選択して再試行してください。"
    },
    EMAILTEMPLATE: {
        TEMPLATE: 'テンプレート',
        ADD_TEMPLATE: 'テンプレートを追加',
        EDIT_EMAIL_TEMPLATE: 'メールテンプレートを編集',
        ADD_EMAIL_TEMPLATE: 'メールテンプレートを追加',
        NAME: 'テンプレート名',
        SUBJECT: '件名',
        //Header
        ADD_DATE: '作成日',
        END_TIME: '最終更新日',
        ACTIVE: '実行',
        MESSAGE: '削除してもよろしいですか？',
        ERROR: 'テンプレート名を入力してください！'
    },
    SMSTEMPLATE: {
        TEMPLATE: 'テンプレート',
        ADD_TEMPLATE: 'テンプレートを追加',
        EDIT_SMS_TEMPLATE: 'SMSテンプレートを編集',
        ADD_SMS_TEMPLATE: 'SMSテンプレートを追加',
        NAME: 'テンプレート名',
        //Header
        ADD_DATE: '作成日',
        END_TIME: '最終更新日',
        ACTIVE: '実行',
        MESSAGE: '削除してもよろしいですか？'
    },
    MANAGEUSERS: {
        RESET_PASSWORD: 'パスワードをリセット',
        RESET_LINK_DESC: '以下のパスワードリセットリンクをユーザーにお伝えください：',
        RESET_LINK_ERROR: 'パスワードリセットリンクを生成できませんでした。しばらくしてから再度お試しください。',
        INVITED_TITLE: 'ユーザーを作成しました',
        INVITED_DESC: '以下のユーザー名とパスワードをユーザーにお伝えください。閉じるとパスワードは再表示できません。',
        INVITED_USERNAME: 'ユーザー名',
        INVITED_PASSWORD: 'パスワード',
        USERMANAGER: "マネージャー",
        SEAT: '利用可能な席数',
        ACTIVATED: '有効化済み',
        UNACTIVATED: '未有効化',
        INVITE_USERS: 'ユーザーを招待',
        MANAGER: '管理者',
        STAFF: 'スタッフ',
        MAIL_TITLE: "Email",
        MAIL: 'Email ログインIDとして使用',
        USER: 'ユーザー',
        FIRST_NAME: 'ユーザー名',
        LAST_NAME: '姓',
        USER_ROLE: '身分',
        INVITE: '招待を送信',
        EDIT_USER: 'ユーザーを編集',
        //Header
        NAME: '名前',
        ROLE: 'ロール',
        IS_SERVICE_AGENT: 'カスタマーサポート',
        IS_TECH_USER: '技術ユーザー',
        IS_PORTAL_USER: 'ポータ ルユーザー',
        IS_PORTAL_USER_ADD: 'Portal ユーザーとして設定',
        IS_VIEW_ONLY_USER: '閲覧のみユーザー',
        LAST_TIME: '最終ログイン時間',
        ACTIVE: '実行',
        MESSAGE: 'このユーザーを無効にしてもよろしいですか？',
        MESSAGE_2: 'このユーザーを再有効化してもよろしいですか？',
        ERROR: '申し訳ありませんが、ユーザー数が上限に達しました。新しいユーザーを追加するには、既存ユーザーの一部を無効化してください。',
        ERROR_2: '申し訳ありません。権限が不足しています。',
        ERROR_3: 'アカウントはすでに存在します。',
        ERROR_4: '少なくとも1人の管理者が必要です。'
    },
    MANAGEGROUPS: {
        ADD_GROUP: 'チームを追加',
        ADD_GPT_GROUP: 'チームを追加',
        EDIT_GPT_GROUP: 'チームを編集',
        GROUP: 'チーム',
        NAME: '名前',
        TYPE: 'タイプ',
        MEMBER: 'メンバー',
        NAME_HINT: '名前を繰り返すことはできません',
        TYPE_HINT: 'この項目は必須です',
        MEMBER_HINT: 'チームには少なくとも1人のメンバーが必要です',
        //Header
        ACTIVE: '実行',
        ERROR: '申し訳ありませんが、権限が不足しています！',
        ERROR_2: 'このチーム名はすでに存在します。',
        MESSAGE: 'このチームを削除してもよろしいですか？',
        MEMBER_SEARCH: 'メンバーを検索',
    },
    CUSTOMFIELDS: {
        SELECT_PROCESS: 'プロセスを選択',
        SELECT_PAGE: 'ページを選択',
        ADD_FIELD: 'フィールドを追加',
        EDIT_OPTION: 'オプションを編集',
        OPTION: 'オプション',
        TREE_OPTION: '階層オプション',
        ADD_CF: 'カスタムフィールドを追加',
        P_SELECT_PAGE: '使用するページを選択してください',
        SELECT_O_PROCESS: '商談プロセスを選択',
        SELECT_C_PROCESS: '案件プロセスを選択',
        SELECT_MESSAGE: 'フォームに追加するフィールドを1つ以上選択してください',
        NAME: 'フィールド名',
        TYPE: 'フィールドタイプ',
        DESCRIPTIONS: 'フィールド説明',
        MANDATORY: '必須かどうか',
        //Header
        ACTIVE: '実行',
        NO_OPPTY_STAGE: '商談プロセスがまだありません',
        NO_CASE_STAGE: '案件プロセスがまだありません',
        ERROR: '少なくとも2つのオプションを残してください',
        ERROR_2: '正しい内容を入力してください',
        ERROR_3: '少なくとも2つのオプションを入力してください',
        ERROR_4: 'まず商談プロセスを追加してください',
        ERROR_5: 'まず案件プロセスを追加してください',
        ERROR_6: '新しいオプションの内容を入力し、Enterキーを押してください',
        MESSAGE: '本当に削除しますか？',
    },
    TABLESETTING: {
        PAGE: 'ページを選択',
        PROCESS: 'プロセスを選択',
        NEW: '新しいテーブルを追加',
        COPY: '現在のテーブルを複製',
        DEFAULT: 'デフォルト',
        NAME: '名前',
        MESSAGE: "このテーブルを削除してもよろしいですか？",
        SET: '設定',
        FIELD: 'フィールド',
        SEQ: '並び順',
        TITLE: '現在のテーブルを編集',
    },
    FILTERSETTING: {
        FILTER: 'フィルター',
        ADD: "フィルターを追加",
        EDIT: "フィルターを編集",
        COPY: "フィルターを複製",
        VISIBILITY: "公開設定",
        VISIBILITY_0: "プライベート",
        VISIBILITY_1: "パブリック",
        DEFAULT: 'デフォルト',
        FILTERFIELD: "フィールドを選択",
        PERSONAL_SETTING: '個人設定',
        SYSTEM_SETTING: 'システム設定',
        CONDITION: "条件を選択",
        ADD_CONDITION: "条件を追加",
        DATE: "日付を選択",
        CAMPAIGN: '関連キャンペーンを選択',
        SEG: '関連セグメントを選択',
        PRODUCT: '製品を選択',
        PARENT_CASE: '親案件を選択',
        TEXT: "テキストを入力",
        NUM: "数値を入力",
        OPT: "オプションを選択",
        TRUE: "はい",
        FALSE: "いいえ",
        INPUT_TO_SEARCH: '会社名を入力して検索してください',
        INPUT_CONTACT_TO_SEARCH: '連絡先名を入力して検索してください',
        INPUT_PRODUCT_TO_SEARCH: '製品名を入力して検索してください',
        INPUT_PARENT_CASE_TO_SEARCH: '親案件名を入力して検索してください',
        ERROR: '少なくとも1つの条件を追加してください',
        ERROR2: 'フィールドを選択してください',
        ERROR3: '検索条件を確認してください',
        MESSAGE: 'このフィルターを削除してもよろしいですか？',
        PUBLIC: '公開',
        PRIVATE: '非公開',
        CS: 'カスタムオプション',
        NO_FILTER: 'フィルターなし',
        DELETED_DATA: '削除されたデータ',
    },
    OP_TEXT: {
        CONTAINS: "含む",
        NOT_CONTAINS: "含まない",
        IS_EMPTY: "空欄",
        NOT_EMPTY: "空欄ではない",
    },
    OP_NUM: {
        EQUAL: "等しい",
        EQUAL_LESS: "以下",
        EQUAL_LARGER: "以上",
        LESS: "未満",
        LARGER: "より大きい",
    },
    OP_DATE: {
        ON: "と等しい",
        ON_OR_AFTER: "と等しい または 以降",
        ON_OR_BEFORE: "と等しい または 以前",
        TODAY: "今日",
        YESTERDAY: "昨日",
        TOMORROW: "明日",
        NEXT_7_DAYS: "今後7日間",
        LAST_7_DAYS: "過去7日間",
        THIS_WEEK: "今週",
        THIS_MONTH: "今月",
        THIS_QUARTER: "今四半期",
        THIS_YEAR: "今年",
        NEXT_WEEK: "来週",
        NEXT_MONTH: "来月",
        NEXT_QUARTER: "次の四半期",
        NEXT_YEAR: "来年",
        LAST_WEEK: "先週",
        LAST_MONTH: "先月",
        LAST_QUARTER: "前の四半期",
        LAST_YEAR: "昨年",
    },
    PIPELINESTAGESETTING: {
        ADD: 'プロセスを追加',
        WORRY: 'チームが商談プロセスやSOPに従っていなくても心配いりません！ここでプロセスを設定するだけで、システムがチームをより良い成果へ導きます。',
        ERROR: 'このプロセスはすでに商談で使用されています。別のプロセスに変更してから削除してください。',
        ERROR_2: 'このプロセスはすでに案件で使用されています。別のプロセスに変更してから削除してください。',
        MESSAGE: '削除してもよろしいですか？',
        DEFAULT_PROCESS: 'システム既定のプロセス'
    },
    CUSTOMERSERVICESETTING: {
        ADD: 'オプションを追加',
        TYPE: '案件タイプ',
        GROUP: '案件グループ',
        CATEGORY: '案件カテゴリ',
        ADD_OPTION: 'カスタマーサービスオプションを追加',
        USEING_TYPE: '使用タイプを選択してください',
        NAME: 'オプション名',
        OPTION_DESCRIPTION: 'オプションの説明',
        //----TAB
        ACTIVE: '実行',
        MESSAGE: '削除してもよろしいですか？',
        ERROR_1: "この案件グループは使用中です",
        ERROR_2: "この案件タイプは使用中です",
    },
    KNOWLEDGEARTICLESUBJECTSETTING: {
        ADD_SUBJECT: 'トピックを追加',
        ADD: 'ナレッジ記事のトピックを追加',
        NAME: 'トピック名',
        DESCRIPTION: 'トピックの説明',
        ACTIVE: '実行',
        MESSAGE: 'このトピックを削除してもよろしいですか？',
    },
    AUTONUMBERSETTING: {
        CASE_SETTING: 'ケース設定',
        PERFIX: '接頭文字',
        SUFFIX: '接尾文字',
        RECODR_TYPE: 'レコードタイプ',
        NUMBER_FORMAT: '番号フォーマット',
        START_NUMBER: '開始番号',
        CURRENT_NUMBER: '現在の番号',
        RESET: '現在の番号をリセット',
        ACTIVATED: '有効化',
        UNACTIVATED: '無効化',
        KA_SETTING: 'ナレッジ記事設定',
        TIME_MODE: '時間モード',
        NUMBER_MODE: '番号モード',
        NO_RECORD: 'レコードがありません',
        MESSAGE: '現在の番号が開始番号より小さいです。リセットしますか？',
        RULE: '文字数は',
        RULE_1: '文字以内にしてください',
        AUTO: 'タイトルを自動入力',
    },
    PRODUCTSETTING: {
        TYPE: '製品タイプ',
        DP: '一般製品',
        SP: 'サービス製品',
        LP: '製品型製品',
        PRODUCT: '製品',
        CATEGORY: 'カテゴリ',
        SERIES: 'シリーズ',
        NAME: '名前',
        PRODUCTCODE: 'シリアル番号',
        PRICR: '定価',
        COST: '原価',
        DESCRIPTIONL: '説明',
        ADD_PRODUCT: '製品を追加',
        EDIT_PRODUCT: '製品を編集',
        ADD_PRODUCT_2: '製品カテゴリを追加',
        EDIT_PRODUCT_2: '製品カテゴリを編集',
        ADD_PRODUCT_3: '製品シリーズを追加',
        EDIT_PRODUCT_3: '製品シリーズを編集',
        MESSAGE: '削除してもよろしいですか？',
        ERROR: 'この製品は使用中です',
        ERROR_2: 'このカテゴリは使用中です',
        ERROR_3: 'このシリーズは使用中です',
    },
    NOTIFICATIONSETTING: {
        ADD_NOTICE: "追加",
        NOTICE: "お知らせ",
        NOTICEBOARD: "掲示板",
        TITLE: "タイトル",
        CONTENT: "内容",
        STATUS: "ステータス",
        ACTIVE: "実行",
        MESSAGE: "このお知らせを削除してもよろしいですか？",
        MESSAGE2: "本当によろしいですか？次回ログイン時に再表示されます。",
        ACTIVATED: "有効化",
        UNACTIVATED: "無効化",
        ERROR: "このお知らせのタイトルはすでに存在します。",
        TIMER: "お知らせの切り替え時間",
        SECONDTIMES: "秒/回"
    },
    INBOX_NOTIFICATION_SETTINGS: {
        ALLOW_WEB_PUSH: "ウェブプッシュ通知を許可する",
        ALLOW_FOLLOW: "フォロー中のレコードが変更されたときに通知する",
        ALLOW_MENTION: "@で言及されたときに通知する",
        ALLOW_REPLY: "購読中の投稿に返信があったときに通知する",
        ALLOW_EMOJI: "購読中の投稿に「いいね」が付いたときに通知する",
    },
    CALENDAR_SYNC_SETTINGS: {
        SELECT_CALENDAR: "カレンダーを選択",
        SYNC_TYPE: "同期モード",
        SYNC_AS: "同期形式",
        PRIVATE_EVENTS: "プライベートイベント",
        SELECT_TO_SYNC: "同期するイベントタイプ",
        SYNC_REGARDING: "関連データの同期",
        PRIVATE_EVENTS_0: "同期しない",
        PRIVATE_EVENTS_1: "同期する",
        SYNC_REGARDING_0: "関連データを含まない",
        SYNC_REGARDING_1: "関連データを含む",
        NO_SELECT_TYPE: "未選択",
        STOP_SYNC: "同期を停止",
        CONNECT_SUCCESS: "M365アカウントの連携に成功しました。カレンダー同期ページでアカウントのメールアドレスをご確認ください。ありがとうございます！",
        SYNC_TYPE_ONE_0: "単方向同期",
        SYNC_TYPE_ONE_1: "UpDayイベントをM365カレンダーへ同期",
        SYNC_TYPE_ONE_2: "UpDayイベントの変更のみUpDayに同期",
        SYNC_TYPE_TWO_0: "双方向同期",
        SYNC_TYPE_TWO_1: "UpDayイベントをM365カレンダーへ同期",
        SYNC_TYPE_TWO_2: "M365カレンダーをUpDayイベントへ同期",
    },
    //--------Common DIALOG
    CHANGEOWNER: {
        TITLE: 'カスタマー担当者の変更',
        TITLE_2: '記事の作成者を変更',
        TITLE_3: '所有者を変更',
    },
    CASECARD: {
        TITLE: '案件',
        NO_CASE: '案件はまだありません',
        CASE_NUMBER: '案件番号',
    },
    PRODUCTTABLE: {
        NO_PRO: '製品はまだありません',
        MESSAGE: 'この製品を削除してもよろしいですか？',
    },
    PRODUCTLINEITEM: {
        QUANTITY: '数量',
        QUANTITY_H: '数量',
        QUANTITY_D: '合計数量',
        DAYS: "日数",
        TAX: '税金',
        TAX_H: '税金',
        UNIT: '単位',
        DISCOUNT: '割引',
        DISCOUNT_H: '割引',
        AMOUNT: '金額',
        AMOUNT_H: '金額',
        SUBTOTAL_LIST_PRICE: '定価小計',
        TOTAL_DISCOUNT: '割引小計',
        SUBTOTAL_AMOUNT: '金額小計',
        SALES_TAX: '売上税額',
        TOTAL: '合計',
        TOTAL_PRODUCTS: '製品総数',
        TAX_INCLUSIVE: '税込金額',
        TAX_EXCLUSIVE: '税抜金額',
        NO_TAX: '税金を計算しない',
        SYSTEM_COMPUTE: 'システム計算',
        MANUAL_INPUT: '手動入力',
        DISCOUNT_DATA: '割引',
        TAX_DATA: '税額',
        OTHER_CHARGES: 'その他の費用',
        ENABLE_TRQ: '時間範囲',
        FROM: '開始日',
        TO: '終了日',
        FROMTOERROR: 'どちらか一方の日付だけではいけません',
        OC_DISCOUNT: 'その他費用の小計',
        OC: 'その他費用',
    },
    CASETABLE: {
        NO_CASE: '案件はまだありません',
        MESSAGE: 'この案件を削除してもよろしいですか？',
        SUBJECT: '件名',
        CONTACT: '連絡先',
        PRIORITY: '優先度',
        STATUS: 'ステータス',
        GROUP: 'グループ',
        TYPE: 'タイプ',
        OWNER: '担当者',
        CLOSED_DATE: '完了日',
    },
    OPPTYCARD: {
        TITLE: '商談',
        NO_OPPTY: '商談はまだありません',
        EXPECTED_CLOSE_DATE: '予想完了日',
    },
    CUSTOMFIELD: {
        TITLE: 'カスタム項目',
        NO_DATA: 'カスタム項目はまだありません',
    },
    EMAILEDITOR: {
        RECIPIENT: '宛先',
        COPY: 'CC',
        ATTACHMENT: '添付ファイル',
        SUBJECT: '件名',
        SEND: '送信',
        CLEAR: 'クリア',
        TEMPLATE: 'メールテンプレート',
        NO_O365: 'M365アカウントが設定されていません。メール送信には「設定 > メール同期」でM365アカウントを設定してください。ありがとうございます！',
        INVALID_O365_TOKEN: 'M365アカウントの認証が長時間使用されていません。「設定 > メール同期」で既存のM365アカウントを削除し、再設定してください。ありがとうございます！',
        NO_DATA: 'データがありません',
        GO_SETTING: '設定へ移動',
        ERROR: '添付ファイルの合計サイズは20MBを超えないようにしてください',
        ERROR_2: 'このメールアドレスの形式は正しくありません',
        ERROR_3: 'メールを送信する前にすべての項目を入力してください',
    },
    SMSEDITOR: {
        ADD: '新規追加',
        RECIPIENT: '受信者',
        NUMBER: '受信番号',
        ENTER: '携帯番号を入力',
        SEND: '送信',
        CLEAR: 'クリア',
        TEMPLATE: 'SMSテンプレート',
        ERROR: '送信前にすべての項目を入力してください',
        ERROR_2: '正しい形式で入力してください',
    },
    LOSEREASON: {
        TITLE: 'カスタマー案件終了',
        TITLE_2: '失敗理由を選択',
        TITLE_3: '商談獲得を確認',
        CASE_NAME: '案件名',
        CONTACT_NAME: '主な連絡先名',
        OPPTY_NAME: '商談名',
        CUSTOMER_NAME: '顧客名',
        CLOSE_DATE: '終了日',
        CLOSE_REASON: '終了理由',
        STATUS: 'ステータス',
        CLOSED: '終了済み',
        OPEN: '進行中',
        AMOUNT: '金額',
        LOSE: '失敗理由',
        WIN: '商談獲得',
    },
    EMAILCAMPAIGNDIALOG: {
        TITLE: 'Emailプレビュー',
        SUBJECT: '件名',
        ATTACHMENT: '添付ファイル',
        MESSAGE: 'Email送信中です。確認を押してキャンペーンページで送信状況を確認してください',
    },
    SMSCAMPAIGNDIALOG: {
        TITLE: 'SMSプレビュー',
        SMS_CONTENT: 'SMS内容',
        MESSAGE: 'SMS送信中です。確認を押してキャンペーンページで送信状況を確認してください',
    },
    ADDPROCESSDIALOG: {
        EDIT: 'プロセス編集',
        ADD_OPPTY: '商談プロセス新規追加',
        ADD_CASE: '案件プロセス新規追加',
        NAME: 'プロセス名',
        PAGE: 'プロセス利用ページ',
        STAGE_NAME: 'ステージ名',
        PROBABILITY: '商談獲得確率',
        FINISH_DAY: '完了予定日数',
        GUIDE: '成功ガイド',
        COLOR: '色',
        DAY: '日',
        ERROR: 'ステージは空にできません',
        ERROR_2: 'このステップは使用履歴があるため削除できません',
        MESSAGE: 'ステップを削除してもよろしいですか？',
    },
    ADDNOTE: {
        TITLE: '備考追加',
        TITLE_2: '備考編集',
        CONTENT: '備考内容を入力してください',
    },
    EMAILATTACHMENTSDIALOG: {
        TITLE: 'メール添付ファイル',
    },
    EMAILCONTACTSDIALOG: {
        TITLE: '関連連絡先',
    },
    EMAILOPPTIESDIALOG: {
        TITLE: '関連商談',
        NO_OPPTY: '関連商談はありません',
        EXPECTED_CLOSE_DATE: '予想終了日：',
    },
    REDIRECTDIALOG: {
        NEW_CONTACT: '新しい連絡先を見る',
        NEW_ORG: '新しい会社を見る',
        NEW_OPPTY: '新しい商談を見る',
        NEW_CASE: '新しい案件を見る',
        NEW_ORDER: '新しい注文を見る',
        NEW_CONTRACT: '新しい契約を見る',
    },
    //------- List.js
    LEVELLIST: { 0: "スタッフ", 1: "マネージャー", 2: "取締役", 3: "Cレベル", 4: "オーナー" },
    KASTATUSLIST: {
        PUBLISHED: '公開済み',
        WAIT_PUBLISH: '公開待ち',
        IN_REVIEW: 'レビュー中',
        AUTHORING: '作成中',
    },
    CASESTATUSLIST: {
        OPEN: '進行中',
        PENDING: '保留中',
        WAIT_CUSTOMER: '顧客待ち',
        WAIT_3RD_PARTY: '第三者待ち',
        RESOLVED: '解決済み',
        CLOSED: 'クローズ',
    },
    OPPTYSTATUSLIST: {
        OPEN: '進行中',
        WON: '商談獲得',
        LOSE: '商談失敗',
    },
    CAMPAIGNTYPELIST: {
        ADVERTISEMENT: '広告',
        DIRECT_MARKETING: 'ダイレクトマーケティング',
        MARKETING_EVENT: 'イベントマーケティング',
        JOINT_MARKETING: '共同マーケティング',
        OTHERS: 'その他',
    },
    CASEPRIORITYLIST: {
        VERY_HIGH: '最高',
        HIGH: '高',
        MEDIUM: '中',
        LOW: '低',
        VERY_LOW: '最低',
    },
    CASESOURCELIST: {
        EMAIL: 'メール',
        WEB_FORM: 'ウェブフォーム',
        WEB_CHAT: 'オンラインサポート',
        PHONE: '電話',
        STORE: '実店舗',
        OUTBOUND: 'アウトバウンド',
        OTHERS: 'その他',
    },
    CLOSECASEREASONLIST: {
        RESOLVED: '解決済み',
        ALTERNATIVE: '代替解決策',
        NO_SOLUTION: '解決策なし',
        NO_RESPONSE: '顧客からの応答なし',
        NOT_AN_ISSUE: '問題ではない',
    },
    CLOSEREASONLIST: {
        null: '進行中の商談',
        0: '商談再開',
        1: '商談獲得',
        2: '競合に敗北',
        3: '相手が行動しない',
    },
    NUMBERTYPELIST: {
        3: '3桁',
        4: '4桁',
        5: '5桁',
        6: '6桁',
        7: '7桁',
        8: '8桁',
        9: '9桁',
        10: '10桁',
        11: '11桁',
        12: '12桁',
        13: '13桁',
        14: '14桁',
        15: '15桁',
    },
    SEGMENT_TYPELIST: {
        STATIC: '固定セグメント',
        DYNAMIC: '動的セグメント',
    },
    STAGEDEFCOLORLIST: {
        0: '赤色',
        1: '橙色',
        2: '黄色',
        3: '緑色',
        4: '青色',
        5: '紫色',
    },
    INDUSTRYLIST: {
        0: '農林漁牧業',
        1: '鉱業および採石業',
        2: '製造業',
        3: '電力およびガス供給業',
        4: '水供給および汚染整備業',
        5: '建設業',
        6: '卸売・小売業',
        7: '運輸・倉庫業',
        8: '宿泊および飲食業',
        9: '出版・映像・情報通信業',
        10: '金融および保険業',
        11: '不動産業',
        12: '専門・科学技術サービス業',
        13: '支援サービス業',
        14: '公共行政・国防；強制的社会保障',
        15: '教育業',
        16: '医療保健および社会福祉業',
        17: '芸術・娯楽・レジャー業',
        18: 'その他サービス業',
    },
    ORGTYPELIST: {
        0: '外国会社の支社',
        1: '外国会社の事務所',
        2: '現地会社の支社',
        3: '協同組合',
        4: '合資会社',
        5: '有限会社',
        6: '有限合資会社',
        7: '合名会社',
        8: 'その他',
        9: '株式会社',
        10: '無限会社',
        11: '個人事業主',
    },
    AGENTSTATUSLIST: {
        ONLINE: 'オンライン',
        AWAY: '離席中',
        BUSY: '忙しい',
        OFFLINE: 'オフライン',
    },
    CONTACTSFIELDLIST: {
        created_on: '作成日時',
        created_by: '作成者',
        updated_on: '更新日時',
        updated_by: '更新者',
        owner: '所有者',
        orgs: '会社名',
        full_name: '連絡先氏名',
        english_full_name: '(英)連絡先氏名',
        english_title: '(英)役職',
        english_department: '(英)部署',
        invoice_recieved: '請求書受領',
        mailing_address: '住所2',
        total_amount: '進行中商談合計額',
        title: '役職',
        email: 'メールアドレス',
        mobile_phone: '携帯電話',
        office_phone: '電話番号',
        description: '説明',
        department: '部署',
        birthdate: '生年月日',
        level: 'レベル',
        fax: 'FAX',
        facebook: 'Facebook',
        linkedin: 'LinkedIn',
        instagram_id: 'Instagram',
        line_id: 'Line',
        billing_address: '住所',
        city: '市区町村',
        country: '国',
        zip_code: '郵便番号',
        province: '県・州',
        primary_campaign_id: '関連キャンペーン',
        seg: 'セグメント',
    },
    ORGSFIELDLIST: {
        created_on: '作成日時',
        created_by: '作成者',
        updated_on: '更新日時',
        updated_by: '更新者',
        owner: '所有者',
        name: '会社名',
        website: 'ウェブサイト',
        company_number: '統一番号',
        main_phone: '電話番号',
        description: '説明',
        industry: '業種',
        employee: '従業員数',
        establish_date: '設立日',
        annual_revenue: '売上高',
        registered_capital: '資本金',
        fax: 'FAX',
        billing_address: '住所',
        sub_address: '住所2',
        city: '市区町村',
        country: '国',
        zip_code: '郵便番号',
        province: '県・州',
        total_amount: '進行中商談合計額',
        organization_type: '種類',
        primary_campaign_id: '関連キャンペーン',
        name_en: '(英)会社名',
        closing_date: '締め日',
        payment_term: '支払条件',
        regular_payment_date: '固定支払日',
        belong_group: '所属グループ',
    },
    OPPTYSFIELDLIST: {
        created_on: '作成日時',
        created_by: '作成者',
        updated_on: '更新日時',
        updated_by: '更新者',
        owner: '商機所有者',
        name: '商機名',
        amount: '金額',
        expected_close_date: '予定終了日',
        closed_date: '終了日',
        closed_reason: '終了理由',
        status: 'ステータス',
        forecast_category: '予測カテゴリ',
        customer_needs: '顧客ニーズ',
        customer_budget: '顧客予算',
        budget_confirmed: '予算確認済み',
        primary_campaign_id: '関連キャンペーン',
        stage_type: 'ビジネスプロセス',
        oppty_contact: '顧客名',
        current_stage: '現在のステージ',
        primary_contact: '主要連絡先',
        description: '説明',
        filter_oppty_contact: '顧客名（連絡先）',
        filter_oppty_org: '顧客名（会社）',
        tax_option: '課税方式',
    },
    CASESFIELDLIST: {
        created_on: '作成日時',
        created_by: '作成者',
        updated_on: '更新日時',
        updated_by: '更新者',
        owner: 'カスタマーサービス担当者',
        subject: '件名',
        case_number: '案件番号',
        due_date: '予定終了日',
        incoming_fullname: '問い合わせ者',
        incoming_phone: '問い合わせ電話番号',
        incoming_email: '問い合わせメール',
        source: '案件ソース',
        status: 'ステータス',
        closed_date: '終了日',
        closed_reason: '終了理由',
        priority: '優先度',
        primary_campaign_id: '関連キャンペーン',
        primary_contact: '連絡先',
        case_org: '会社',
        group: 'グループ',
        type: 'タイプ',
        stage_type: '案件プロセス',
        current_stage: 'ステージ',
        description: '案件説明',
        resolution: '案件対応',
        product: '製品',
        parent_case_id: '親案件',
    },
    CASEDASHBOARD: {
        TITLE: 'カスタマーサポート案件ダッシュボード',
        UNSOLVED: '未解決',
        OVERDUE: '期限超過',
        DUE_TODAY: '本日期限',
        CLOSED: '終了済み',
        OPEN: '進行中',
        ON_HOLD: '保留中',
        HIGH_PRIORITY: '高優先度',
        AVERAGE_RESOLVED_TIME: '平均処理時間',
        DAY: '日',
        HOUR: '時間',
        MIN: '分',
        PRIORITY: '優先度',
        SOURCE: '問い合わせ元',
        GROUP: 'グループ',
        TYPE: 'タイプ',
        PROCESS: '処理プロセス',
        LINE_CHART: '案件折れ線グラフ',
        RECEIVED: '受理案件数',
        RESOLVED: '解決案件数',
        CASE_RANKING: '案件処理ランキング',
        CASES: '件',
        UP: '上昇',
        DOWN: '下降',
        AGENT_STATUS: 'カスタマー担当者ステータス',
        AGENT_TOTAL: 'カスタマー担当者総数'
    },
    UPCHATDASHBOARD: {
        TITLE: 'チャットインタラクションダッシュボード',
    },
    CAMPAIGNSTAUSLIST: {
        PROPOSED: '提案済み',
        READY_TO_ACTIVATE: '起動準備完了',
        ACTIVATED: '起動済み',
        COMPLETED: '完了',
        CANCELLED: 'キャンセル済み',
        SHELVED: '保留',
        NOT_IN_USE: '未使用',
    },
    IMPORT_EXPORT: {
        TITLE: 'データのインポート',
        TITLE_2: 'データのエクスポート',
        IMPORT: 'インポート',
        EXPORT: 'エクスポート',
        PAGE: 'ページ',
        DATATYPE: 'エクスポートデータ',
        STAGE: 'ステージ',
        DOWNLOAD: 'ダウンロード',
        TEMP: 'テンプレート',
        DB_DATA: '全データ',
        SELECT: 'ファイルを選択',
        NOTICE: '注意事項',
        DOWNLOAD_TEMP: 'インポート用テンプレートをダウンロード',
        ERROR: 'このブラウザはエクスポート機能に対応していません。ChromeかEdgeの使用を推奨します。',
        CONTACT_LABEL: '注意事項\n1. ID欄に入力がある場合、データは更新されます\n2. Owner欄に入力する際は、名前の間にスペースを入れてください。例：陳 振凱\n3. Company Name、Campaign欄の内容が存在しない場合、自動で作成されます\n4. カスタムフィールド名が重複するか、既存のフィールド名と同じ場合、データは上書きされます\n5. データに科学記数法が含まれる場合は、Excelでセルの書式設定を調整し、データ保存ミスを避けてください\n6. 日付を入力する場合は、yyyy-mm-dd形式で入力してください',
        ORG_LABEL: '注意事項\n1. ID欄に入力がある場合、データは更新されます\n2. Owner欄に入力する際は、名前の間にスペースを入れてください。例：陳 振凱\n3. Campaign欄の内容が存在しない場合、自動で作成されます\n4. カスタムフィールド名が重複するか、既存のフィールド名と同じ場合、データは上書きされます\n5. データに科学記数法が含まれる場合は、Excelでセルの書式設定を調整し、データ保存ミスを避けてください\n6. 日付を入力する場合は、yyyy-mm-dd形式で入力してください',
        OPPTY_LABEL: '注意事項\n1. ID欄に入力がある場合、データは更新されます\n2. Owner、Oppty Contact、Primary Contact欄に入力する際は、名前の間にスペースを入れてください。例：陳 振凱\n3. Oppty Org、Oppty Contact、Primary Contact、Campaign欄の内容が存在しない場合、自動で作成されます\n4. カスタムフィールド名が重複するか、既存のフィールド名と同じ場合、データは上書きされます\n5. データに科学記数法が含まれる場合は、Excelでセルの書式設定を調整し、データ保存ミスを避けてください\n6. 日付を入力する場合は、yyyy-mm-dd形式で入力してください\n7. Stage Typeは変更しないでください。Current Stageが正しく入力されていることを確認してください',
        CASE_LABEL: '注意事項\n1. ID欄に入力がある場合、データは更新されます\n2. Owner、Primary Contact欄に入力する際は、名前の間にスペースを入れてください。例：陳 振凱\n3. Primary Contact、Case Org、Campaign、Group、Type欄の内容が存在しない場合、自動で作成されます\n4. カスタムフィールド名が重複するか、既存のフィールド名と同じ場合、データは上書きされます\n5. データに科学記数法が含まれる場合は、Excelでセルの書式設定を調整し、データ保存ミスを避けてください\n6. 日付を入力する場合は、yyyy-mm-dd形式で入力してください\n7. Stage Typeは変更しないでください。Current Stageが正しく入力されていることを確認してください\n8. Case Number欄が空欄の場合、連番設定に従い自動作成されます',
        KA_LABEL: '注意事項\n1. ID欄に入力がある場合、データは更新されます\n2. Owner欄に入力する際は、名前の間にスペースを入れてください。例：陳 振凱\n3. Subject欄の内容が存在しない場合、自動で作成されます\n4. データに科学記数法が含まれる場合は、Excelでセルの書式設定を調整し、データ保存ミスを避けてください\n5. Content欄はHTML形式で入力してください\n6. Article Number欄が空欄の場合、連番設定に従い自動作成されます',
        PRODUCT_LABEL: '注意事項\n1. ID欄に入力がある場合、データは更新されます\n2. Owner欄に入力する際は、名前の間にスペースを入れてください。例：陳 振凱\n3. Category、Series欄の内容が存在しない場合、自動で作成されます\n4. データに科学記数法が含まれる場合は、Excelでセルの書式設定を調整し、データ保存ミスを避けてください\n5. 日付を入力する場合は、yyyy-mm-dd形式で入力してください',
        ORDER_LABEL: '注意事項\n1. ID欄に入力がある場合、データは更新されます\n2. Owner、Contact欄に入力する際は、名前の間にスペースを入れてください。例：陳 振凱\n3. Organization欄の内容が存在しない場合、自動で作成されます\n4. データに科学記数法が含まれる場合は、Excelでセルの書式設定を調整し、データ保存ミスを避けてください\n5. 日付を入力する場合は、yyyy-mm-dd形式で入力してください',
        LICENSE_LABEL: '注意事項\n1. ID欄に入力がある場合、データは更新されます\n2. Owner、Contact、Contact2、Contact3欄に入力する際は、名前の間にスペースを入れてください。例：陳 振凱\n3. Contact、Contact2、Contact3、Organization、Product欄の内容が存在しない場合、自動で作成されます\n4. データに科学記数法が含まれる場合は、Excelでセルの書式設定を調整し、データ保存ミスを避けてください\n5. 日付を入力する場合は、yyyy-mm-dd形式で入力してください',
        SERVICE_LABEL: '注意事項\n1. ID欄に入力がある場合、データは更新されます\n2. Owner、Contact、Contact2、Contact3欄に入力する際は、名前の間にスペースを入れてください。例：陳 振凱\n3. Contact、Contact2、Contact3、Organization、Product欄の内容が存在しない場合、自動で作成されます\n4. データに科学記数法が含まれる場合は、Excelでセルの書式設定を調整し、データ保存ミスを避けてください\n5. 日付を入力する場合は、yyyy-mm-dd形式で入力してください',
        FLEXFIELD_LABEL: '注意事項\n1. ID欄に入力がある場合、データは更新されます\n2. 入力内容が該当フィールドの形式に合っていることを確認してください\n3. データに科学記数法が含まれる場合は、Excelでセルの書式設定を調整し、データ保存ミスを避けてください\n4. 日付を入力する場合は、yyyy-mm-dd形式で入力してください',
        COPY: 'メッセージをコピー',
        ERROR_2: 'インポートファイルの内容を確認するか、テンプレートに入力してください',
        ERROR_3: 'データ件数が多いため、システムはバックグラウンドでインポート処理を続行しています。データがまだ完全にインポートされていない場合は、しばらく待ってからページを再読み込みしてください。',
        COPY_2: 'コピーしました',
        SEARCH: '検索文字列',
        ING: '処理中',
        OPPTY_PRODUCT: '商機製品をエクスポート',
        PROGRESS: '現在の進捗: ',
        STILL_RUN: 'インポート処理が進行中です。「インポート/アップロード履歴」へ進んで進捗を確認しますか？',
    },
    UPCHAT: {
        TITLE: 'メッセージ履歴',
        SENDER: '送信者: ',
        SENDER_B: '送信者: ロボット',
        ROBOT: 'ロボ',
        NO_MESSAGE: 'まだ対話履歴がありません',
        SHOW: 'メッセージを表示',
        CHANNEL: 'メッセージソース',
        BLANK: '対話をクリックして連絡先情報を表示してください',
        NO_AGENT: '担当カスタマーサービスが未割り当てです',
        SYNC: 'この連絡先を同期してもよろしいですか？',
        CIC: 'UpDay 顧客インタラクションセンター',
    },
    DOCUMENT: {
        TITLE: 'ファイル',
        NO_DOC: 'ファイルがありません',
        NAME: '名前',
        DESCRIPTION: "説明",
        CREATE: '作成日時',
        UPDATE: '更新日時',
        ADD: 'ファイルを追加',
        EDIT: 'ファイルを編集',
        DEL: 'ファイルを削除',
        NEW_FILE: '新しいファイルを選択',
        MESSAGE_DEL: 'このファイルを削除してもよろしいですか？',
        MESSAGE_DEL_2: 'これらのファイルを削除してもよろしいですか？'
    },
    END_CUSTOMER: {
        TITLE: 'エンドカスタマー',
        ADD: 'データを追加',
        EDIT: 'データを編集',
        NO_DATA: 'データがありません',
        DEL: 'このエンドカスタマーを削除してもよろしいですか？',
        NAME: 'エンドカスタマー名',
    },
    BULK_EDIT: {
        TITLE: '一括編集',
        CHANGE_STAGE: 'ステージを更新',
        MESSAGE: `以下の案件を更新してもよろしいですか？`,
        MESSAGE_CONTACT: '以下の連絡先を更新してもよろしいですか？',
        MESSAGE_OPPTY: '以下の商機を更新してもよろしいですか？',
        MESSAGE_ORG: '以下の会社を更新してもよろしいですか？',
        MESSAGE_DATA: '選択された ',
        MESSAGE_DATA_2: ' 件のデータを更新してもよろしいですか？',
        MESSAGE_EMPTY: '更新するデータを選択してください',
        ERROR_CASE: '以下の案件は既にクローズされています。一括編集を行う場合は、クローズ理由を空にしてください。',
        ERROR_DEAL: '以下の商機は既にクローズされています。一括編集を行う場合は、クローズ理由を更新し、商機を再開してください。',
    },
    BULK_EDIT_LIST: {
        0: '元のデータを維持',
        1: 'データを更新',
        2: '空にする',
    },
    INBOX: {
        SEND: '送信',
        TITLE: '掲示板',
        UNREAD: '未読',
        ALL: 'すべて',
        POST: '投稿',
        ALERT: 'アラート',
        FOCUS: '注目投稿',
        NWE_POST: '新規投稿',
        SUBSCRIBE: '購読',
        UNSUBSCRIBE: '購読解除',
        READ_MORE: '全文表示',
        READ_LESS: '一部表示',
        DELETE: "この投稿を削除してもよろしいですか？",
        DELETE_ALERT: "このアラートを削除してもよろしいですか？",
        CONTENT_EMPTY: "内容が空です！",
        CONTENT_NOT_EMPTY: "閉じると入力した内容が失われます。本当に閉じますか？",
        FILE_LIMIT: "アップロードファイルの合計サイズは20MBを超えられません",
        ALL_READ: "すべてを既読にする",
        ALL_DELETE: "すべての投稿を削除",
        ALL_DELETE_CHECK: "すべての投稿を削除してもよろしいですか？",
        ALL_DELETE_ALERT: "すべてのアラートを削除",
        ALL_DELETE_ALERT_CHECK: "すべてのアラートを削除してもよろしいですか？",
        ERROR_POST: 'この投稿は削除されている可能性があります。INBOXをリフレッシュしてください。',
        NO_NOTIFICATION: '新しいメッセージはありません。少し休憩しましょう〜',
        ALL_HAVE_READ: 'おめでとうございます、すべてのメッセージを読みました！',
    },
    FOLLOW: {
        CONTACT: "選択した連絡先をフォロー/フォロー解除",
        ORG: "選択した会社をフォロー/フォロー解除",
        CASE: "選択した案件をフォロー/フォロー解除",
        OPPTY: "選択した商機をフォロー/フォロー解除",
        FOLLOW: 'フォロー',
    },
    UPLOADSTATUS: {
        METHOD: '方法',
        TYPE: 'タイプ',
        CREATE_TIME: "作成日時",
        UPDATED_TIME: "更新日時",
        FILE_NAME: "ファイル名",
        TOTAL: "合計",
        SUCCESS: "成功",
        FAIL: "失敗",
        STATUS: "状態",
        COMMENT: "記録",
        UPLOAD: 'アップロード',
        IMPORT: 'インポート',
        PROCESSING: "処理中",
        COMPLETE: "完了",
        EMBEDDING: "解析中",
        SHOW: '記録表示',
        NO_RECORD: '記録なし',
        MESSAGE_DELETE: '記録を削除 ',
    },
    AL_MAIL: {
        TITLE: 'AI作成アシスタント',
        GENERATE: "AIメッセージ生成",
        SETTING: "AI生成設定",
        SEND_ALL: "全て送信",
        TONE: "トーン",
        LENGTH: "長さ",
        LANGUAGE: "言語",
        TIP: "ヒント",
        SIGN: "署名",
        REMAKE: "再生成",
        REMAKEING: "生成中...",
        NO_AMIL: "AIメッセージなし",
        SENDING: "送信中...",
        FOLLOWUP: "問い合わせに返信",
        SUMMARY: "要約を作成",
        CUSTOM: "カスタム",
        TONE_1: "プロフェッショナル",
        TONE_2: "リラックス",
        TONE_3: "刺激的",
        TONE_4: "面白い",
        TONE_5: "情熱的",
        LEN_1: "短い",
        LEN_2: "中くらい",
        LEN_3: "詳細",
        STATUS_1: "メッセージなし",
        STATUS_2: "生成済み",
        STATUS_3: "保存済み",
        STATUS_4: "未保存",
        STATUS_5: "失敗",
        CHANGE_ERROR: "プッシュチャネルや顧客グループを変更すると生成済みメッセージは削除されます。",
        UNDO: "元に戻す",
        REMAKE_ALL: "既存データを削除し、現在の設定でメッセージを生成してもよろしいですか？",
        SEND_CHECK: "全てのメッセージを送信してもよろしいですか？<br>送信後は既存のメッセージと設定が削除されます。",
        MAKE_MSG: "メッセージを生成中です。しばらくお待ちください。<br>更新をクリックすると進捗を確認できます。",
        SMS_VENDOR: "SMSサービスプロバイダを「三竹簡訊」に設定してください。このサービスが有効でない場合はUpDayサポートチームにお問い合わせください。",
        NO_CONTACT: "利用可能な連絡先がありません"
    },
    SERVICE_PRODUCT_LINE: {
        ORDER_STATUS: '注文状況',
        OWNER: '担当営業',
        REMAIN_DAYS: '期限までの日数',
        END_ACCOUNT_NAME: 'エンドユーザー名',
        CONTACT: '連絡先',
        TYPE: 'タイプ',
        PROJECT_NAME: 'サポートパッケージ/プロジェクト名',
        SLA: 'SLA',
        SERVICE_CONTENT: '運用内容',
        SERVICE_PLAN: '運用プラン',
        SERVICE_VENDOR: '運用ベンダー',
        START_DATE: '開始日',
        END_DATE: '検収/終了日',
        ORDER_NUMBER: '注文番号',
        STATUS: '状態',
        NOTE: '備考',
        SO: 'SO',
        SO_LINE: 'SOライン',
        PO: 'PO',
        PROJECT_CODE: 'プロジェクトコード',
        RELATED_OPPTY: '関連商機',
        TECH: '技術者',
        TECH_COST: '技術者費用',
        INVOIVE_MONTH: '請求月',
        INVOICE_PRICE: '請求金額',
        ESTMATED_G_P: '推定粗利益',
        POFIT: '利益 (%)',
        ORGANIZATION: '会社名',
    },
    LICENSE_PRODUCT_LINE: {
        PRODUCT_NAME: "製品名",
        ORDER_STATUS: '注文状況',
        OWNER: '担当営業',
        REMAIN_DAYS: '期限までの日数',
        END_ACCOUNT_NAME: 'エンドユーザー名',
        CONTACT: '連絡先',
        TYPE: 'タイプ',
        PRODUCTCODE: '項目番号',
        BILLING_F: '課金頻度',
        START_DATE: '購入/開始日',
        END_DATE: '終了日',
        ORDER_NUMBER: '注文番号',
        STATUS: '状態',
        NOTE: '備考',
        SO: 'SO',
        SO_LINE: 'SOライン',
        PO: 'PO',
        PROJECT_CODE: 'プロジェクトコード',
        RELATED_OPPTY: '関連商機',
        TECH: '技術者',
        TECH_COST: '技術者費用',
        INVOIVE_MONTH: '請求月',
        INVOICE_PRICE: '請求金額',
        ESTMATED_G_P: '推定粗利益',
        POFIT: '利益 (%)',
        SUBCRIPTION_NUMBER: 'サブスクリプション識別子',
        AGREEMENT_NUMBER: '契約番号',
        CONTRACT_LEVEL: '契約レベル',
        CONTRACT_NUMBER: '契約番号',
        PA_NUMBER: 'PA番号',
        OKS_NUMBER: 'OKS番号',
        CSI_NUMBER: 'CSI番号',
        RENEW_ID: 'OCI更新ID',
        INSTANCE_NUMBER: 'インスタンス番号',
        ORGANIZATION: '会社名',
    },
    PRODUCT_LINE_ITEM_LIST: {
        1: "すべて",
        2: "仮保存",
        3: "審査中",
        4: "審査承認済み",
        5: "差戻し",
        6: "有効中",
        7: "有効中・追加資料待ち",
        8: "追加資料提出済み・審査待ち",
        9: "更新済み",
        10: "更新しない",
        11: "停止中",
        12: "移行",
        13: "年契約・年払い",
        14: "年契約・月払い",
        15: "月契約・月払い",
        16: "一括払い",
        17: "毎月請求",
        18: "請求なし",
        19: "試用",
        20: "プロジェクト型",
        21: 'サービスケース数ベース',
        22: 'サービス時間ベース',
        23: '7*24運用サービス',
        24: '包括契約',
        25: 'プロジェクト型',
        26: 'なし',
        27: '自社運用',
        28: '外注ベンダー',
        29: 'Azure使用量%制',
        30: '緯謙OP',
        31: '緯謙技術',
        32: '外注ベンダー',

        33: '新規購入',
        34: '追加購入',
        35: '更新',
        36: 'アップグレード',
        37: '停止',
        38: '移行',
        39: '交換',
        40: '試用',
        41: '永久ライセンス',
    },
    OPPTY_SELECT_FIELDS_LIST: {
        1: "作成",
        2: "追跡中",
        3: "成約済み",
        4: "未成約",
        5: "フォローアップ",

        6: "ハイテク",
        7: "製造業",
        8: "情報/ソフトウェア",
        9: "政府機関",
        10: "教育（学校）",
        11: "その他公的機関",
        12: "病院",
        13: "医療関連",
        14: "建設",
        15: "小売/卸売",
        16: "ホテル/民宿",
        17: "コンサル/投資",
        18: "金融/会計",
        19: "保険",
        20: "NPO/財団法人",
        21: 'サービス業',
        35: 'デフォルト',

        22: 'ウェブリード',
        23: 'カスタマーサービス電話',
        24: '公式サイト',
        25: 'カスタマーサービスメール',
        26: 'イベント',
        27: '営業商機',
        28: 'その他',

        29: '0%(連絡待ち)',
        30: '20%(交渉中)',
        31: '40%(販売中)',
        32: '60%(価格交渉中)',
        33: '80%(成約)',
        34: '100%(入金)', // 35は21で使用済み
    },
    // GPT----------------------------------------------------------------
    GPT_MENU: {
        DASHBOARD: "ダッシュボード",
        KNOWLEDGE: "知識ベース",
        CHATBOT: "AIロボット",
        CHATBOTS: "AIロボット",
        CHAT_HISTORY: "チャット履歴",
        USER_MANAGEMENT: "ユーザー管理",
        GROUP_MANAGEMENT: "チームマネジメント",
        DATA_CENTER: "データセンター",
        USAGE_ANALYSIS: "利用状況分析",
        UPLOADSTATUS: 'アップロード履歴',
        BACKTO: "戻る",
        MEETINGRECAP: "会議記録",
        AINOTEBOOK: "AIノートブック",
        PORTAL: "Portal",
        USER_ANALYSIS: "会話分析",
        LOGIN_PAGE_SETTING: "ログインページ設定",
    },
    KB_AND_BOT_PERMISSION_SETTING: {
        PERMISSION_SETTING: "権限設定",
        MANAGER: "管理者",
        VIEWER: "閲覧者",
        ONLY_SYSTEM_ADMIN: "システム管理者のみ",
        CUSTOM_SETTING: "カスタマイズ",
        ALL_USER: "すべてのユーザー",
        SEARCH_USER: "ユーザーを検索",
        SEARCH_GROUP: "グループを検索",
        CLEAR_SEARCH: "検索をクリア",
        SELECT_ALL_RESULTS: "検索結果をすべて選択",
        NO_MATCH_USER: "「{q}」に一致するユーザーが見つかりません",
        NO_MATCH_GROUP: "「{q}」に一致するグループが見つかりません",
    },
    GPT_KNOWLEDGE: {
        TITLE: "知識ベース概要",
        UPLOADER: "アップロード者",
        UPLOAD_TIME: "アップロード日時",
        FILE_STATUS: "ステータス",
        STATUS_COMPLETE: "アップロード完了",
        STATUS_PROCESSING: "処理中",
        PROCESS_METHOD: "処理方法",
        NAME: "知識ベース名",
        DOCS: "ドキュメント数",
        CREATED_ON: "作成日",
        UPDATED_ON: "更新日",
        UPDATED_BY: "更新者",
        ROBOTS: "ロボット",
        BACKTO: "戻る",
        LAST_UPDATED: "最終更新",
        OPEN_LIB: "開く",
        CLOSE_LIB: "閉じる",
        ONOFF: "知識ベースの開閉",
        LINKBOT: "AIロボットに連携",
        NO_LINKBOT: "未連携",
        CLEAR: "クリア",
        CLEAR_ALL: "知識ベースをクリア",
        DELETE_SIMPLE: '削除',
        DELETE: '知識ベースを削除',
        DEL_MSG: "この知識ベースを削除してもよろしいですか？",
        CLEAR_MSG: "この知識ベースをクリアしてもよろしいですか？",
        SETTING: "知識ベース設定",
        UPLOAD: "知識ベースファイルアップロード",
        ERROR: "この知識ベース名は既に存在します",
        PUBLIC: "全域全域知識ベース",
        ISPUBLIC: "共有済み",
        ADD_COLUMN: "列を追加",
        EDIT_COLUMN: "列を編集",
        ADD: "追加",
        EDIT: "編集",
        CLEAR_ERROR: "知識ベースファイルをクリア中です。しばらくして画面をリロードしてください。",
        DELETE_ERROR: "知識ベースファイルクリア後に削除します。しばらくして画面をリロードしてください。",
        SYSTEM_NAME_ERROR: "同じSystem Nameが他の知識ベースに存在します。再入力してください。",
        SINGAL_DELETE: "このファイルを削除してもよろしいですか？",
        MULTIPLE_DELETE: "選択したファイルを削除",
        MULTIPLE_DELETE_CHECK: "選択した {count} 件のファイルを削除してもよろしいですか？",
        MULTIPLE_DELETE_PROGRESS: "削除済み {done} / 全 {total} 件",
        MULTIPLE_DELETE_RESULT: "削除完了：成功 {success} 件、失敗 {fail} 件。失敗したファイルは処理中の可能性があります。しばらくしてから再読み込みしてください。",
        DELETEING: "ファイル削除中です。しばらくしてページをリロードしてください。",
        IMAGE_SELECTION: "画像処理オプション",
        TIP_1: "以下のファイルで知識ベースを作成します。AIロボットはこの知識ベースの内容で質問に回答します。",
        TIP_2: "Q&Aファイルをここにアップロードしてください。ファイルはcsv形式でUTF-8エンコードが必要です。",
        TIP_3: "zip形式の圧縮ファイルをここにアップロードしてください。ファイルはフォルダに入れず直接圧縮してください。",
        TIP_4: "txt、pdf、docx、pptxファイルをここにアップロードしてください。csvファイルはQ&Aデータアップロードから行ってください。",
        TIP_4_IDP: "pdf、docx、pptx、xlsxファイルをここにアップロードしてください。csvファイルはQ&Aデータアップロードから行ってください。",
        TIP_5: "分析したいウェブサイトをここに最大5件まで追加できます。深さは最大2です。追加後、「分析開始」を押してください。",
        TIP_6: "JPG、JPEG、PNG形式の画像をここにアップロードしてください。",
        TIP_7: "記録は21日間保持されます",
        TIP_8: "pdf、docx、pptx、jpg、jpeg、png 形式をここにアップロードします。",
        SYSTEM_NAME_TIP: "英語で入力してください。重複不可。AIのナレッジ検索に役立ちます。例：HR, Product, Safetyなど",
        SYSTEM_NAME_LABEL: "System Name",
        DESCRIPTION_TIP: "説明はAIが知識の意味を理解する助けになります。",
        CATEGORY: "カテゴリ",
        PROCESSING_FILE: "処理中のファイル",
        KNOWLEDGE_FOLDER: "ナレッジベースフォルダ",
        KNOWLEDGE: "知識ベース",
        UPDATE_FOLDER_PERMISSION: "この権限をすべてのサブフォルダーおよびナレッジベースに適用しますか? この操作により、サブフォルダーおよびナレッジベースの権限が上書きされます。",
        MOVE_SAME_LOCATION: "選択した場所は現在と同じです。別のフォルダを選択してください。",
        MOVE_NO_PERMISSION: "このナレッジベースまたは移動先フォルダの管理権限がないため、場所を変更できません。",
        MOVE_FAIL: "場所の変更に失敗しました。しばらくしてから再度お試しください。",
    },
    ADD_KNOWLEDGE: {
        TITLE: '新しい知識ベース',
        KB: 'ナレッジベース',
        FOLDER: 'フォルダ',
        CATEGORY: "カテゴリ",
        CATEGORY_PH: "カテゴリを選択または新規作成",
        CATEGORY_HTNT: "ナレッジ種別。例：人事、製品、情報部など。",
        NAME: '名前',
        NAME_PH: "知識ベース名",
        NAME_HINT: '名前は重複不可。作成後は変更できません。',
        SYSTEM_NAME_HINT: "英語で入力し、重複不可。システム識別用。",
        DESCRIPTION: '説明',
        DESCRIPTION_PH: "100文字以内で入力してください。",
        DESCRIPTION_HINT: "説明は必須項目です。AIが情報を理解し検索する助けになります。",
    },
    KNOWLEDGE_FOLDER: {
        library: 'ナレッジベース',
        folder: 'フォルダ',
    },
    ADD_KNOWLEDGE_FOLDER: {
        TITLE: 'フォルダを追加する',
        EDIT_TITLE: '知識を編集する',
        NAME: '名称',
        PATH: '親階層',
        PERMISSION_SETTING: '権限設定',
        PERMISSION_SETTING_DEFAULT: '（デフォルトの権限設定は親レイヤー用です）',
        ONLY_SYSTEM_ADMIN: 'システム管理者のみ',
        ONLY_SYSTEM_VIEWER: 'すべてのユーザー',
        CUSTOM_SETTING: 'カスタム',
        DELETE_MSG: 'この操作を行うと、すべてのサブフォルダとナレッジベースが削除されます。削除してもよろしいですか？',
        ERROR1: '現在選択されているパスは以前と同じです。フォルダの場所は変更されません。もう一度選択してください。',
        ERROR_2: '親フォルダーを自分自身のサブフォルダーに設定することはできません。',
        ERROR_3: 'フォルダー名は既に存在します。もう一度入力してください。'
    },
    FOLDER_LOCATION_PICKER: {
        TITLE: "フォルダーを選択",
        CURRENT: "現在の選択",
        NOT_SELECTED: "未選択",
        CREATE_FOLDER: "フォルダー作成",
        PLACEHOLDER: "フォルダーを選択…",
        DRAFT_HINT: "新規",
        NEW_FOLDER_DEFAULT: "新しいフォルダー",
    },
    GPT_UPLOADIMG: {
        DESCRIBE_IMG: '画像理解',
        CUSTOMER_ATTRIBUTE: 'カスタム属性',
        IMG_SEARCH: '画像検索',
        IDP: 'インテリジェントドキュメント処理',
        TIP_1: "AIが画像を詳細に説明し、ユーザーはそれをもとに質問し答えを探せます。",
        TIP_2: "AIが画像から属性を抽出し表に保存します。「アジアで最も高価なトップ3の物」などの質問に有効です。利用にはお問い合わせください。",
        TIP_3: "AIが送信された画像を分析し類似画像を探します。製品検索などに便利です。",
        FILEUPLOADMESSAGE: 'JPG、JPEG、PNGファイルのみ対応',
        START_ANALYSIS: '分析開始',
        IMAGE_STATUS: '状態',
        IMAGE_TIP_1: "画像処理機能はエンタープライズ版のみ利用可能です。support@upday.aiまでご連絡ください。",
        IMAGE_TIP_2: "インテリジェントドキュメント処理はエンタープライズ版のみ利用可能です。support@upday.aiまでご連絡ください。",
        IMAGE_TIP_3: "画像処理機能とインテリジェントドキュメント処理はエンタープライズ版のみ利用可能です。support@upday.aiまでご連絡ください。",
        CLOUD_TIP: "クラウドファイル処理機能はエンタープライズ版のみ利用可能です。support@upday.aiまでご連絡ください。",
    },
    GPT_CLOUD: {
        CONNECT_CLOUD: 'クラウド連携',
        CONNECT_ACCOUNT: 'アカウント連携',
        RESET: 'リセット',
        SAVE: '保存',
        DELETE_CHECK: 'このクラウドアカウント設定を削除してもよろしいですか？\n確認すると、すべての連携ファイルが知識ベースから削除されます。',
        CLOUDSYNC_ERROR: '削除に失敗しました。再試行してください。',
        MY_DRIVE: 'マイドライブ',
        SHARE_WITH_ME: '共有済み',
        SHAREPOINT: 'Sharepoint',
        ONEDRIVE_LOCKED: 'このアカウントの OneDrive は現在アクセスできません（ロック中）。Microsoft 365 管理者に解除をご依頼ください。',
        ONEDRIVE_ACCESS_FAILED: 'OneDrive へのアクセスに失敗しました。時間をおいて再度お試しいただくか、管理者にお問い合わせください。',
        EXCEED_MAX_SIZE: 'アップロードファイルの合計サイズが超過しました',
        MAX_FILES: "ファイル数が多すぎます。先頭2000件のみ表示しています。",
    },
    GPT_ANALYSIS: {
        NAME: "データ分析",
        USED_TOKEN: "使用済みトークン",
        MSG_TOKEN: "メッセージあたりの平均トークン消費",
        MSG_Q: "メッセージ数",
        MSG_PER_Q: "平均トークン消費",
        ACU: "累積使用トークン",
        THIS_PERIOD: '今期',
        PREVIOUS: '前期',
        TABLE_HEADER_1: "スマートロボット",
        TABLE_HEADER_2: "チャネル",
        TABLE_HEADER_3: "プロンプトトークン",
        TABLE_HEADER_4: "完了トークン",
        TABLE_HEADER_5: "費用",
        TABLE_HEADER_6: "時間",
        TABLE_HEADER_7: "知識ベース",
        TABLE_HEADER_8: "利用タイプ",
        TABLE_HEADER_9: "テナント",
        TABLE_HEADER_10: "有効期限",
        STORAGE_USAGE: 'ストレージ使用量',
        IMAGE_STORAGE_USAGE: '画像ストレージ使用量',
        STORAGE_USAGE_TIP: "すべての知識ベースで連携されているファイルサイズ",
        IMAGE_STORAGE_USAGE_TIP: "すべての知識ベースで連携されている画像数",
        INTELLIGENT_DOCUMENT_USAGE_TIP: "すべてのインテリジェントドキュメント処理の利用数",
        USED: '使用済み',
        PIECE: "枚",
        PAGE: "ページ",
        END_DATE: ' 有効期限:',
        REMAIN_AMOUNT: '残高',
        USING_AMOUNT: '使用量'
    },
    GPT_TREADANALYSIS_DRAWER: {
        THREAD: "トピック",
        FEEDBACK: "役に立った",
        HELPFUL: "役に立つ",
        UNHELPFUL: "役に立たない",
        ACCURACY: "正確度",
        RELEVANCE: "関連度",
        REFERENCES: "参照",
        ANSWER: "回答",
    },
    GPT_USER_ANALYSIS: {
        ANSWER: '回答',
        HELPFUL: "役に立つ",
        UNHELPFUL: "役に立たない",
        RELEVANCY: '関連度',
        RELEVANCY_H: '関連度高い',
        RELEVANCY_L: '関連度低い',
        STATISTICS: "統計",
        RELATED: "関連あり",
        UNRELATED: "関連なし",
        ACCURACY: "正確度",
        ACCURACY_H: "正確度高い",
        ACCURACY_L: "正確度低い",
        DATE: "日付",
        CATEGORY: "カテゴリ",
        AVG_RELEVANCY: "平均関連度",
        AVG_ACCURACY: "平均正確度",
        TOTAL_ANSWER: "回答総数",
        HELP_UNHELP: "役に立つ/役に立たない",
        THIS_WEEK: "今週",
        RECORDS: "件",
        ALL: "すべて",
        TODAY: "今日",
        THIS_MONTH: "今月",
        DATE_RANGE: "日付範囲選択",
        LAST_7_DAYS: "過去7日間",
        SELECT_DATE_RANGE_ERROR: "日付範囲を入力してください"
    },
    GPT_THREAD_ANALYSIS: {
        THREAD_ANALYSIS: "話題総覧",
        DATE: "日付",
        THREAD_NAME: "話題",
        ANSWER: '回答',
        HELPFUL: "返答",
        ACCURACY: "正確度",
        RELEVANCY: "関連度",
        FILES: "参考資料",
        NO_FEEDBACK: "未回答"
    },
    GPT_IDP: {
        DOCUMENT_ANALYSIS: 'インテリジェントドキュメント処理',
        REMAIN_DOCUMENT_ANALYSIS: '残りのインテリジェントドキュメント数',
        DOCUMENT_ANALYSIS_STORAGE_USAGE: 'インテリジェントドキュメント処理使用量',
        TIP_1: 'インテリジェントドキュメント処理を使ってドキュメントを分析します。利用可能なクォータはデータ分析ページでご確認ください。',
    },
    GPT_AIBOTS: {
        TITLE: "AIロボット総覧",
        AIASSISTANTNAME: 'AIロボット名',
        AIASSISTANTNAME_TIP1: 'AIロボットの名前を設定してください',
        AIASSISTANTNAME_TIP2: '例: 小安',
        AIASSISTANTROLE: 'AIロボットの役割',
        AIASSISTANTROLE_TIP1: 'AIロボットの役割を設定してください',
        AIASSISTANTROLE_TIP2: '例: UpDay CRMのカスタマーサービスエージェント（安然科技株式会社設計）',
        TOPIC: 'テーマ',
        TOPIC_TIP1: 'AIロボットにテーマを与え、質問の書き換えをよりよく行います',
        TOPIC_TIP2: '例: UpDay CRM',
        TOPICLIMIT: 'テーマ制限',
        TOPICLIMIT_TIP1: '質問がテーマから逸脱した場合、AIロボットは元のテーマ範囲に戻って回答します',
        TOPICLIMIT_TIP2: '例: technology',
        REPLY_LANGUAGE: '返信言語',
        REPLY_LANGUAGE_TIP: 'AIロボットは選択された言語で返信します',
        MODEL: 'AIモデル',
        MEMORY_LENGTH: 'ロボットの記憶長さ',
        RETURN_KNOWLEDGE: '使用する知識量',
        INBOX: "受信箱",
        HAS_LINKED_BOT: "この受信箱には他のロボットが連携されています。",
        NO_EXIST_BOT: "まだUpChatロボットがありません。UpGPTサポートに連絡して設定してください。",
        VERBOSITY: "回答の詳細",
        REASONING_EFFORT: "推論エンゲージメント"
    },
    ADD_AIBOTS: {
        TITLE: '新規AIロボット追加',
        NAME: '名前',
        DESCRIPTION: '説明',
        INBOX: "受信箱",
        KNOWLEDGE: "知識ベース",
        CONNECT_TO: "接続先",
        MEMORY_LENGTH: '記憶長さ',
        RETURN_KNOWLEDGE: '使用知識量',
        RETURN_TONE: '返信トーン',
        RETURN_LEN: '返信長さ',
        AI_DISCLAIMER: 'AI免責事項を許可',
        CITATION: '引用元表示を許可',
        FILELINK: 'ファイルリンクを返す',
        IMAGE_SEARCH: '画像検索を許可',
        RETURN_IMAGE_QUANTITY: '返信画像数',
        RETURN_REPLY_WITH_IMAGE: '画像付き返信を許可',
        SHOW_ALL_IMAGE: "画像をすべて表示",
        HIDE_ANSWER_WITHOUT_REFERENCE: "参考資料なし：回答非表示",
        SHOW_PRIVATE_KNOWLEDGE: "プライベートナレッジベースを表示",
        WEB_SEARCH_TOGGLE: "ウェブ検索を許可する",
        ROLE: "役割",
        SCOPE: "返信制限",
        TOPIC: "テーマ",
        ONOFF: "AIロボットのオン/オフ",
        DETAIL: "AIロボット詳細情報",
        BRAIN_SIZE: "知識蓄積",
        C_SETTING: "役割設定",
        DEL_MSG: "このAIロボットを削除してもよろしいですか？",
        BEST_SIZE: "推奨サイズ: 120*30px",
        M_1: "知識の微調整設定。",
        M_2: "AIロボットは提供された知識ベースに基づいて応答します。",
        M_3: "記憶長さを増やすと文脈参照が増えますが、応答速度が遅くなります。\n使用知識量を増やすとより精度の高い応答が得られますが速度は遅くなります。",
        M_4: "AIロボットは利用者の役割設定に応じて反応・応答します。",
        M_5: "役割は応答のトーンや態度に影響します。",
        M_6: "質問がテーマから外れた場合、AIロボットは元のテーマ範囲に戻って回答します。",
        M_7: "AIロボットにテーマを与え、質問の書き換えをより良くします。",
        M_8: "AIロボットの自称名。",
    },
    DETAIL_LEVEL: {
        "CONCISE": "簡潔",
        "NORMAL": "標準",
        "DETAILED": "詳細",
    },
    TONE_LEVEL: {
        "PROFESSIONAL": "プロフェッショナル",
        "FRIENDLY": "親しみやすい",
        "CASUAL": "カジュアル",
        "INSPIRING": "インスピレーションを与える",
        "PASSIONATE": "情熱的",
        "WARM": "暖かい",
    },
    GPT_UPLOAD: {
        DEL_K: "削除済み知識ベース",
        AutoSync: "クラウド自動同期",
        ManualSync: "クラウド手動同期",
        AutoKnow: "連携済み知識ベース"
    },
    GPT_USER: {
        T_1: "個人情報",
        T_2: "パスワード変更",
    },
    GPT_CHAT_HISTORY: {
        CHANNEL: "チャネル",
        C_USER_NAME: "ユーザー名",
        LAST_CHAT_TIME: "最終チャット時間",
        L_SELECT: "左側からチャットを選択してください",
        SEARCH: "メッセージ検索",
    },
    GPT_MEETINGRECAPS: {
        TITLE: "会議記録一覧",
        NAME: "名称",
        participants: "参加者",
        OWNER: "所有者",
        TIME: "時間",
        DELETE: "この会議記録を削除してもよろしいですか？"
    },
    GPT_MEETINGRECAP: {
        TITLE: "会議記録",
        NAME: "会議名",
        MS: "会議概要",
        OWNER: "所有者",
        MS_TIME: "会議時間",
        ANR: "関連AIノートブック",
        AN: "AIノート",
        OPPTY: "商機",
        ANs: "AIメモ",
        TS: "文字記録",
        ANALYZE: "AI分析",
        SUGGEST_TASKS: "タスク提案",
        CREATE_TASKS: "タスク作成",
        VIEW_TASKS: "タスク閲覧",
        SUMMARY: "要約生成",
        VALIDATE: "必須項目を確認し、商機に紐付けてください。",
        NO_T: "文字記録がありません。",
        DELETED_MEETING_RECAP: "この会議記録は削除されました。ページを更新してください。",
        EXIST_SUMMARY_AND_TASK: "会議の要約およびタスクが生成されています。ページを更新して内容をご確認ください。",
        MAIL_SETTING: "メール設定確認中",
        MAIL_GENERATE: "AIメール生成中",
        EMPTY_SUMMARY: "AIは空白の会議要約から適切なメールを生成できません。",
        EMPTY_CUSTOM_PROMPT: "AIは空白のプロンプトから適切なメールを生成できません。",
        EMPTY_SUMMARY_TASK: "AIは空白の会議要約から適切なタスクを生成できません。",
        TASK_CANT_FIND_ACTIVITY: "関連するアクティビティが削除されました。新しいタスクを作成してください。",
    },
    GPT_AINOTEBOOK: {
        TITLE: "AIノートブック一覧",
        LAST_UPDATED: "最終更新",
        DESCRIPTION: '説明',
        RECORD_TYPE: '記録タイプ',
        DELETE: "このAIノートブックを削除してもよろしいですか？",
        DELETE_ERROR: "最低1つのAIノートブックが必要です",
        DEFAULT: "システムデフォルト",
        CRM_TIP: "会議で小安に自動取得してほしいCRMデータを選択してください。",
        AI_NOTE_TIP: "会議で小安に自動取得してほしいデータをカスタマイズしてください。",
    },
    ADD_AINOTEBOOK: {
        TITLE: 'AIノートブック追加',
        EDIT: 'AIノートブック編集',
        ADD: 'フィールド追加',
        COLUMN: 'フィールド',
        NAME: '名前',
        DESCRIPTION: '説明',
        DELETE_ERROR: "このフィールドを削除してもよろしいですか？",
        NAME_HINT: 'AIノートブック作成後は名前を変更できません。',
        COLUMN_NAME_HINT: 'フィールド作成後は名前を変更できません。',
        LIMIT_HINT: 'フィールド説明は50文字以内で入力してください。',
        LIMIT_COLUMNS: 'フィールド数が上限に達しました。',
        CRM_SYSTEM_FIELD: 'CRMの項目',
    },
    //Up Meeting
    UPMEETING: {
        LOGIN: "UpSide AI アシスタント",
        ANN: "小安",
        CHANGE_AN: "AIノートブックを変更すると、記録された情報は消去されます。",
        NOTE_C: "欄がすべて入力されました。",
        MEETING_OVER: "会議は終了しました。以下のリンクから記録を確認してください：",
        L_D_TITLE: "前回参加した会議を継続しますか？",
        L_D_LAST: "前回の会議を続ける",
        L_D_NEW: "新しい会議を開始する",
        FINISH: "終了",
        CAPTION_ERROR: "まずTeamsかGoogle会議を開いてください。",
        IMAGE_PREFIX: "AI問題分析中...",
        QUERY_PREFIX: "AIキーワード生成中...",
        SEARCH_PREFIX: "AI情報分析中...",
        IMAGE_ERROR: "画像分析に失敗しました。もう一度お試しください。",
        BACKEND_ERROR: "権限がないか、システム設定が正しくありません。システム管理者にお問い合わせください。",
        SHOT_BTN_TITLE: "AI情報分析",
        NO_QA: "AIアイコンをクリックするかキーワードを入力して検索してください。",
        Problem_Analysis: "問題分析",
        Causes_Analysis: "原因分析",
        Solutions: "解決策",
        Actions: "行動",
        References: "参考資料",
        OutlookError: "メールが開かれていないか、設定が合っていません",
        VisionOn: '映像オン',
        VisionOff: '映像オフ',
        WAITING: "データの読み取りと分析中です。少々お待ちください。",
    },
    // Order
    ORDER: {
        TITLE: '注文',
        WIADVANCE_TITLE: '契約',
        NAME: '注文名',
        WIADVANCE_NAME: '契約名',
        ENDACCOUNT: 'エンドユーザー名',
        CLIENT_NAME: '顧客名',
        ORGANIZATION_NAME: '会社名',
        ENDACCOUNT_NAME: 'エンド顧客名',
        CONTACT_NAME: '担当者',
        SHIPPING_METHOD: '配送方法',
        PAYMENT_TERM: '支払条件',
        SHIPPING_TERM: '送料条件',
        BILLING_ADDRESS: '請求先住所',
        SHIPPING_ADDRESS: '配送先住所',
        DESCRIPTION: '説明',
        AMOUNT: '金額',
        ORDER_STATUS: '注文状況',
        WIADVANCE_ORDER_STATUS: '契約状況',
        ORDER_SALES: '担当営業',
        FROM_DATE: '期限までの日数',
        TYPE: 'タイプ',
        BILLING_FREQUENCY: '請求頻度',
        PRODUCT_CODE: '製品コード',
        PROJECT_CODE: 'プロジェクトコード',
        PRODUCT_NAME: '製品名',
        QUANTITY: '数量',
        START_DATE: '開始日',
        PURCHASE_ACTIVATION_DATE: '購入/開始日',
        ACCEPTANCE_COMPLETION_DATE: '受領/終了日',
        DUE_DATE: '終了日',
        ORDER_NUMBER: '注文番号',
        STATUS: '状態',
        NOTE: '備考',
        PROJECT_NAME: 'サポートパッケージ / プロジェクト名',
        SERVICE_CONTENT: 'メンテナンス内容',
        SERVICE_PLAN: 'メンテナンスプラン',
        MESSAGE_DEL_ORDER: 'このデータを削除してもよろしいですか？',
        SERVERS: 'サーバー',
    },
    ORDER_DETAIL: {
        ORDER_TYPE: '注文タイプ',
        WIADVANCE_ORDER_TYPE: '契約タイプ',
        OWNER: '注文所有者',
        WIADVANCE_ORDER_OWNER: '契約所有者',
        NO_REGARDING: '会社名を入力して検索してください',
        TIMELINE: 'タイムライン',
        NO_TIMELINE: 'タイムラインなし',
        //----TAB      
        DETAIL: '詳細情報',
        PRODUCT: '製品',
    },
    ADD_ORDER: {
        TITLE: '注文追加',
        WIADVANCE_TITLE: '契約追加',
        NAME: '注文タイトル',
        WIADVANCE_NAME: '契約タイトル',
        ORZ: '顧客選択',
        CONTACT: '担当者選択',
        NO_CONTACT: '担当者名を入力して検索してください',
        NEW_CONTACT: '新規担当者作成',
        OLD_CONTACT: '既存担当者選択',
        AMOUNT: '金額',
        SHIPPING_METHOD: '配送方法',
        PAYMENT_TERM: '支払条件',
        SHIPPING_TERM: '送料条件',
        BILLING_ADDRESS: '請求先住所',
        SHIPPING_ADDRESS: '配送先住所',
        FIRST_NAME: '名',
        LAST_NAME: '姓',
    },
    SHIPPINH_METHODS: {
        AIR_FREIGHT: '航空便',
        MAIL_DELIVERY: '郵便配達',
        FULL_LOAD: 'フルロード',
        PICK_UP: '引き取り',
    },
    SHIPPINH_TERM: {
        FREE_SHIPPING: '送料無料',
    },
    PAYMENT_TERM: {
        PAYMENT_WITHIN_30D: '30日以内支払い',
        PAYMENT_WITHIN_30D2PERCENT: "2%割引、10日以内支払い、30日以内全額支払い",
        PAYMENT_WITHIN_45D: "45日以内支払い",
        PAYMENT_WITHIN_60D: "60日以内支払い",
        PAYMENT_WITHIN_90D: "90日以内支払い",
    },
    THEDAYOFEVERYMONTH: {
        1: '毎月1日',
        2: '毎月2日',
        3: '毎月3日',
        4: '毎月4日',
        5: '毎月5日',
        6: '毎月6日',
        7: '毎月7日',
        8: '毎月8日',
        9: '毎月9日',
        10: '毎月10日',
        11: '毎月11日',
        12: '毎月12日',
        13: '毎月13日',
        14: '毎月14日',
        15: '毎月15日',
        16: '毎月16日',
        17: '毎月17日',
        18: '毎月18日',
        19: '毎月19日',
        20: '毎月20日',
        21: '毎月21日',
        22: '毎月22日',
        23: '毎月23日',
        24: '毎月24日',
        25: '毎月25日',
        26: '毎月26日',
        27: '毎月27日',
        28: '毎月28日',
        29: '毎月29日',
        30: '毎月30日',
        31: '毎月31日',
    },
    ORDER_TYPE: {
        LICENSE_PRODUCT: '製品型契約',
        SERVICE_PRODUCT: 'サービス型契約',
        LICENSE_CONTRACT: '製品型契約',
        SERVICE_CONTRACT: 'サービス型契約',
    },
    AGENT: {
        ICON: 'アイコンを選択',
        TITLE: 'AI エージェント',
        GOAL: '説明（任意）',
        GOAL_Mandatory: '目的',
        IMAGE_INPUT: '画像',
        QUESTION: '質問',
        INSTRUCTION: '指示',
        KNOWLEDGE_LIBS: '知識ベース',
        UN_UPDATED: '更新なし',
        CUSTOMER: '顧客',
        SOLUTION: '解決策',
        PRODUCTS: '製品',
        FILE: 'ファイルアップロード',
        TRANSLATE_TO: '翻訳する',
        ADD_FIELD: 'フィールドを追加',
        FIELD_TYPE: 'フィールドタイプ',
        FIELD_NAME: 'フィールド名',
        SYSTEM_NAME: 'システム名',
        DEFAULT_VALUE: 'フィールドのデフォルト値',
        IS_MANDATORY: '必須項目として設定',
        CHOOSE_FILE_HINT: 'ファイルを選択してください',
        LABEL_PREVIOUS_STEP: '前のステップの文書を読み込む',
        LABEL_UPGPT_KNOWLEDGE: 'UpGPTの知識内の特定の文書を読み込む',
        AGENT_NAME_Construction_Compliance_Agent: '建設コンプライアンスエージェント',
        AGENT_NAME_Proposal_Writing_Agent: '提案作成エージェント',
        AGENT_NAME_Employee_Onboarding_Agent: '社員オンボーディングアシスタント',
        AGENT_NAME_Document_Translation_Agent: '文書翻訳アシスタント',
        AGENT_DESCRIPTION_Construction_Compliance_Agent: 'ユーザーから提供された写真や質問に基づいて、建設現場の安全情報、建設指示書、チェックリスト、手順、コンプライアンス関連の資料を検索する責任を負います。',
        AGENT_DESCRIPTION_Proposal_Writing_Agent: '提供された指示、サンプル、情報に基づいて提案書を作成します。',
        AGENT_DESCRIPTION_Employee_Onboarding_Agent: '社員の入社に関する質問への回答、関連情報の検索、そして社員体験の向上を支援します。',
        AGENT_DESCRIPTION_Document_Translation_Agent: '従業員が文書の内容を指定された言語に翻訳できるように支援します。',
        SEARCH_IMAGE_BY_IMAGE_NUM_IMAGE_RETURN: '取得する画像数',
        SEARCH_KNOWLEDGE_NUM_OF_SUBQUERIES: '関連質問数',
        IGNORE_LANGUAGE_SETTING: '言語設定を無視',
        INCLUDE_IN_CITATION: '段落ごとに引用',
        OUTPUT_FORMAT: '出力形式',
        STEP_user_input: 'ユーザー入力',
        STEP_search_image_by_image: '画像で検索',
        STEP_read_document: 'ファイルを読み込む',
        STEP_think: '思考',
        STEP_search_knowledge: '知識を検索',
        STEP_respond: 'レスポンス',
        TEXT_MESSAGE: "テキストを入力",
        KNOWLEDGE_MESSAGE: "  使用するナレッジベースを紐づける",
        STEP: "ステップ",
        READ_DOCUMENT_DESCRIPTION: "文書を読取...",
        THINK_DESCRIPTION: "思考分析...",
        SEARCH_IMAGE_BY_IMAGE_DESCRIPTION: "画像から関連画像検索...",
        SEARCH_KNOWLEDGE_DESCRIPTION: "知識庫及資料検索...",
        RESPOND_DESCRIPTION: "前段階基づき回答生成",
        FOLLOW_UP_QUESTION: "拡張質問",
        CONTENT: "関連内容",
        ADD_AGENT: "エージェントを追加",
        ADD_SIMPLE_AGENT: "エージェントを追加",
        EDIT_SIMPLE_AGENT: "エージェントを編集する",
        AGENT_NAME_MSG: "エージェント名を入力してください",
        SEARCH_WEB: "ウェブを検索",
        BIND_LIB: 'ナレッジベースを選択',
        BIND_FOLDER: 'フォルダーを選択',

    },
    AGENT_FILE_ATTACHMENT: {
        ATTACHMENT: "添付ファイル",
        UPLOAD: "クリックしてファイルを選択またはここにドラッグします",
        ACCEPT_TYPE: "受け入れ可能なファイル形式 {file_type}",
        UPLOADING: "ファイルのアップロード",
        EXCEED_MAX: "システムでは最大3つのファイルしかサポートされません。制限を満たすファイル数を再選択してください。",
        STILL_RUN: 'ファイルのアップロードが進行中です。後でページを更新してください。',
        WRONGTYPEINFILE: 'ファイルのアップロードには、pdf、docx、pptx、jpg、jpeg、png ファイルのみ受け付けられます。',
        DRAG_HINT: 'ここにファイルをドラッグ、最大 3 個、.pdf .docx .pptx .jpg .png に対応',
        EXCEED_MAX_TOAST: '最大3つのファイルをアップロードできます',
        EXCEED_SIZE_TOAST: 'ファイルの合計サイズは 20MB を超えることはできません',
    },
    AGENT_STEP: {
        STEP: 'ステップ',
        ANSWER: '答え',
    },
    // Document Agent
    DOCUMENT_AGENT: {
        TITLE: "AI処理センター",
        TEMPLATE_TITLE: "テンプレートを選択",
        LINK_ACCOUNT: "连结帐号",
        ACCESS_FOLDER: "アクセスフォルダ",
        GENERATE_CONSET_FORM: "同意書を生成する",
        SYNC_UPDATE: "同期更新",
        NO_DATA: "表示できるデータがありません",
        PROPERTIES: "フィールド設定",
        REGENERATE: "再生成",
        SHOWALL: "すべてのデータを表示",
        DELETE_CHECK: 'このクラウド アカウント設定を削除してもよろしいですか?\n確認すると、リンクされたファイルはすべて削除されます。',
        DELETE_FILE_CHECK: 'このデータ リンク設定を削除してもよろしいですか?\n確認すると、リンクされたファイルはすべて削除されます。',
        NO_REFERENCE_USED: "参照が使用されていません",
        AI_DISCLAIMER: "AI can make mistakes. Please verify.",
        RUN_AGENT: "Run Agent",
        RUN_ALL: "Run All",
        TOTAL: "合計",
        UNSUPPORTED_FILE_FORMAT: 'ファイル形式はサポートされていません',
        FILE_FORMAT_TOOLTIP: 'pdf、docx、pptx、xlsx、png、jpg、jpeg、gif、webp 形式に対応しています',
        UNSUPPORTED_FILES_SUMMARY: '{successCount} 件のファイルがアップロードされました。\n{failCount} 件はサポートされていない形式のため、アップロードできませんでした。',
        IMAGE_PAGE_INFO: "{page_num} ページ、{image_num} 枚目の画像",
        DOWNLOAD_FAILED: 'ファイルのダウンロードに失敗しました。後でもう一度お試しください。',
        BLANK_TEMPLATE: '空白テンプレート',
        CREATOR: '作成者',
        CREATOR_ADMIN: '管理者',
        AI_GENERATE_TITLE: 'Work Agent に何をしてもらいたいですか？',
        AI_GENERATE_PLACEHOLDER: 'プロンプトを入力してテンプレートを生成するか、直接作成してください',
        AI_GENERATE_BTN: 'AI生成',
        RETRY_BTN: '再試行',
        DIRECT_CREATE_BTN: '直接作成',
        SAVE_AS_TEMPLATE: 'テンプレートとして保存',
        SAVE_AS_TEMPLATE_HEADER: 'テンプレートとして保存',
        SAVE_AS_TEMPLATE_NAME: '名前',
        SAVE_AS_TEMPLATE_DESC: '説明',
        SAVE_AS_TEMPLATE_STATUS: 'ステータス',
        SAVE_AS_TEMPLATE_PRIVATE: 'プライベート',
        SAVE_AS_TEMPLATE_PUBLIC: '公開',
        SAVE_AS_TEMPLATE_DUPLICATE_MSG: '同じ名前のテンプレートが既に存在します。引き続き保存しますか？',
        SAVE_AS_TEMPLATE_SAVE_BTN: '保存',
        SAVE_AS_TEMPLATE_NAME_REQUIRED: 'テンプレート名は必須です',
        DELETE_TEMPLATE_CONFIRM: 'この操作により {name} テンプレートを完全に削除します。削除してもよろしいですか？\n作成済みの Work Agent は引き続き正常に使用できます。',
        DELETE_TEMPLATE_FAILED: 'テンプレートの削除に失敗しました。もう一度お試しください。',
        AI_GENERATE_ERROR_TIMEOUT: 'AI生成がタイムアウトしました。再試行するか「直接作成」を選択してください。',
        AI_GENERATE_ERROR_SERVICE: 'AIサービスでエラーが発生しました。再試行するか「直接作成」を選択してください。',
        AI_GENERATE_ERROR_FORMAT: 'AIの返答フォーマットが無効です。プロンプトを修正するか「直接作成」を選択してください。',
        AI_GENERATE_ERROR_CREATE: 'Work Agentの作成に失敗しました。再試行するか「直接作成」を選択してください。',
        OPEN_FILE: 'ファイルを開く',
        FILE_TYPE_NOT_SUPPORTED: 'このファイル形式はプレビューに対応していません',
        FILE_LOAD_ERROR: 'ファイルの読み込みに失敗しました。後でもう一度お試しください',
        NO_EXTRACTED_TEXT: 'このファイルには表示できるテキストがありません',
        NO_FILE_IN_COLUMN: 'この項目にはファイルがありません',
        NO_PREVIEWABLE_FILE: 'このレコードにはプレビュー可能なファイルがありません',
        PREVIEW_LOAD_ERROR: 'プレビューを読み込めません。更新するか、ファイルを直接開いてください',
        PREVIEW_FETCH_ERROR: 'プレビューリンクの取得に失敗しました。後でもう一度お試しください',
        EXTRACT_TEXT_ERROR: 'ドキュメントのテキスト抽出に失敗しました。後でもう一度お試しください',
        RECORD_DELETED: 'このレコードは削除されました',
        RECORD_COUNT: '{current} / {total}',
        RECORD_REVIEW: 'レコードレビュー',
        COLLECTION_LOAD_ERROR: 'サブコレクションデータの読み込みに失敗しました',
        DATA_LOAD_ERROR: 'フィールドデータの読み込みに失敗しました。しばらくしてからもう一度お試しください',
        EXPAND: '展開',
        COLLAPSE: '折りたたむ',
        VIEW_ORIGINAL_FILE: '元のファイル',
        VIEW_EXTRACTED_TEXT: '抽出テキスト',
        PDF_PREVIEW_LOAD_ERROR: 'プレビューを読み込めません。再度切り替えるか、ファイルを直接開いてください。',
        PDF_PREVIEW_FETCH_ERROR: 'プレビューリンクの取得に失敗しました。しばらくしてから再試行してください。',
        REF_MODE_TEXT: "テキストモード",
        REF_MODE_PDF: "PDFモード",
        REF_MODE_WEB: "Web参照",
        WEB_SEARCH_EMPTY: "この検索ではウェブ上の情報が見つかりませんでした。",
        CELL_ERROR_DEFAULT: 'このフィールドの実行中にエラーが発生しました。',
        CELL_ERROR_TIMEOUT: '実行タイムアウト',
        CELL_ERROR_FAILURE: '実行失敗',
        SORT_ASC: '昇順',
        SORT_DESC: '降順',
        SORT_CLEAR: '並び替えをクリア',
        SORT_TOOLTIP: 'クリックで並び替え、再クリックで方向切替またはクリア',
        FILTER_CONTAINS: '含む',
        FILTER_NOT_CONTAINS: '含まない',
        FILTER_EQUALS: '等しい',
        FILTER_NOT_EQUALS: '等しくない',
        FILTER_GT: 'より大きい',
        FILTER_GTE: '以上',
        FILTER_LT: 'より小さい',
        FILTER_LTE: '以下',
        FILTER_BETWEEN: '範囲内',
        FILTER_IS_EMPTY: '空である',
        FILTER_IS_NOT_EMPTY: '空でない',
        FILTER_APPLY: '適用',
        FILTER_CLEAR: 'クリア',
        FILTER_CLEAR_ALL: 'すべてのフィルターをクリア',
        MENU_SORT: '並べ替え',
        MENU_FILTER: 'フィルター',
        NO_FILTER_RESULT: 'フィルター条件に一致するデータがありません',
    },
    WORK_AGENT: {
        PERMISSION_SETTINGS: '権限設定',
        MANAGE_ACCESS: 'アクセス管理',
        SHARE_BTN: '共有',
        ENTITY_TYPE_TEMPLATE: 'Work Agent テンプレート',
        ENTITY_TYPE_INSTANCE: 'Work Agent インスタンス',
        OWNER_LABEL: 'オーナー',
        VISIBILITY_LABEL: '可視性',
        VISIBILITY_PRIVATE: 'プライベート (Private)',
        VISIBILITY_PUBLIC: '公開 (Public)',
        PRIVATE_DESCRIPTION: 'オーナーと管理者のみ閲覧可能',
        PUBLIC_DESCRIPTION: '全テナントユーザー',
        MANAGER_ONLY_BANNER: '管理者 (is_staff) のみがテンプレートの可視性と共有を設定できます。',
        INSTANCE_OWNER_ONLY_INFO: 'このWork Agentの公開設定と共有はオーナーのみが管理できます。共有された方は閲覧と実行のみ可能です。',
        PRIVATE_SHARING_HINT: 'プライベートの場合、アクセスを明示的に付与する必要があります。ユーザーとグループの両方を同時に設定できます。',
        SHARE_TO_USER: 'ユーザーに共有',
        SHARE_TO_GROUP: 'グループに共有',
        SEARCH_USER_PLACEHOLDER: 'ユーザーまたはメールを検索...',
        SEARCH_GROUP_PLACEHOLDER: 'グループを検索...',
        SHARE_USER_DESC_TEMPLATE: '共有されたユーザーは、テンプレート選択ダイアログでこのテンプレートを見つけ、Work Agent を作成できます（読み取り専用、テンプレートの編集・削除は不可）。',
        SHARE_USER_DESC_INSTANCE: '共有されたユーザーはこの Work Agent を閲覧・実行できます（読み取り専用、編集・削除は不可）。',
        SHARE_GROUP_DESC: 'グループメンバーの変更は即時反映され、現在のグループ名簿に基づいて可視性が解決されます。',
        SELECT_ALL: 'すべて選択',
        SAVING: '保存中...',
        SAVED: '保存しました',
        PUBLIC_WARNING_TEMPLATE: '公開に設定すると、全テナントユーザーが閲覧・使用できるようになり、個別の共有設定は不要です。既存の指定共有は可視性に影響しなくなります（既存の設定は削除されません）。',
        PUBLIC_WARNING_INSTANCE: '公開に設定すると、全テナントユーザーがこの Work Agent を閲覧・実行できるようになり、個別の共有設定は不要です。既存の指定共有は可視性に影響しなくなります（既存の設定は削除されません）。',
        NO_EDIT_PERMISSION: 'この Work Agent を編集する権限がありません',
        NO_DELETE_PERMISSION: 'この Work Agent を削除する権限がありません',
        NO_MANAGE_ACCESS_PERMISSION: 'アクセス管理の権限がありません',
        ERROR_NO_PERMISSION: 'この操作を実行する権限がありません',
        ERROR_SHARE_SAVE_FAILED: 'アクセス権設定の保存に失敗しました。後でもう一度お試しください。',
        ERROR_SHARE_REMOVE_FAILED: '共有設定の削除に失敗しました。後でもう一度お試しください。',
        ERROR_ONEDRIVE_TOKEN_EXPIRED: 'ソース接続が無効です。オーナーに再認証を依頼してください。',
        ACCESS_REVOKED_TITLE: 'この Work Agent にアクセスできません',
        ACCESS_REVOKED_MESSAGE: 'この Work Agent へのアクセス権限がオーナーによって変更または取り消されました。ページを再読み込みして一覧を更新してください。',
        REFRESH_PAGE: 'ページを再読み込み',
    },
    DOCUMENT_AGENT_SELECT: {
        SELECT_FOLDER: "フォルダを選択",
        LINK_ACCOUNT: "リンクされたアカウント"
    },
    DOCUMENT_AGENT_PROPERTY: {
        NAME: "名称",
        TYPE: "タイプ",
        MODEL: "モデル",
        INPUT: "入力",
        DESCRIPTION: "指示",
        COLLECTION_PROPERTIES: "コレクションデータ項目",
        COLLECTION_NAME_DUPLICATE: "この名前はすでにコレクションテーブルで使用されています。別の名前に変更してください",
        USER_PROMPT: "指示",
        REASONING_EFFORT: "推論エンゲージメント",
        OPTIONS: "オプション",
        READ_DOCUMENTS:"参考資料",
        CHOOSE_READ_DOCUMENTS:"参考資料を選択してください",
        CHOOSE_INPUT_COLUMN:"入力フィールドを選択してください",
        FILL_COLUMN_NAME:"列名を入力してください",
        FILL_PROMPT:"指示を入力してください。",
        FILE_UPLOAD: "ファイルアップロード",
        ONEDRIVE_FILE: "OneDriveファイル",
        TEXT: "テキスト",
        NUMBER: "数値",
        COLLECTION: "コレクション",
        SINGLE_SELECT: "単一選択",
        DOCUMENT_OUTPUT: "ドキュメント出力",
        ERROR_DOCUMENT_OUTPUT_IN_COLLECTION: "ドキュメント出力タイプの項目は、コレクション子テーブルには作成できません。",
        ERROR_ONEDRIVE_IN_COLLECTION: "OneDrive のファイル種別の項目は、コレクション子テーブルには作成できません。",
        ERROR_ONEDRIVE_ONLY_ONE: "1つのテーブルに作成できる OneDrive のファイル種別の項目は 1 つまでです。",
        LOADED_ALL: "すべて読み込みました",
        CONFIRM_UPDATE_TO_ONEDRIVE: "この操作により既存のデータが削除されます。更新してよろしいですか？",
        ERROR_DUPLICATE_COLUMN_NAME: "同じ階層のテーブル内で、列の名前を重複させることはできません。",
        TEMPLATE: "テンプレート",
        TEMPLATE_PLACEHOLDER_DOCX_ONLY: ".docx形式のみ受け付けます",
        TEMPLATE_REUPLOAD: "再アップロード",
        TEMPLATE_DELETE: "削除",
        TEMPLATE_DELETE_CONFIRM: "アップロード済みのテンプレートを削除してもよろしいですか？",
        TEMPLATE_FORMAT_ERROR: "無効なフォーマットです。.docx ファイルのみ受け付けます。",
        COLLAPSE: "折りたたむ",
        EXPAND: "展開する",
        NO_DATA: "データなし",
        COLLECTION_SUMMARY: "{count} 件のコレクションデータ",
        PYTHON_TOOL: "Python ツール",
        MODEL_LIST_NOT_CONFIGURED: "このテナントの Work Agent モデル設定が未作成または不正です。管理者にお問い合わせください。",
        VISION_MODEL: "ビジョンモデル",
        NO_VISION_MODEL: "利用可能なビジョンモデルがありません。管理者にお問い合わせください。",
        MODEL_LIST_LOAD_FAILED: "モデル一覧を取得できませんでした。しばらくしてからお試しください。",
        PYTHON_CODE: "コード",
        PYTHON_CODE_HINT: "出力を result に代入してください。入力フィールドを変数として使用できます。",
        PYTHON_CHAR_COUNT: "現在：{count} / 5,000 文字",
        CONFIRM_LEAVE_PYTHON: "Python ツールを離れると、現在のスクリプトが破棄されます。続行しますか？",
        TOOL_SELECTOR_LABEL: "ツール",
        TOOL_OPTION_NONE: "（なし）",
        VALIDATION_EMPTY_SCRIPT: "コードは空にできません。",
        VALIDATION_MISSING_RESULT: "スクリプトは 'result' に値を代入する必要があります。",
        VALIDATION_SYNTAX_ERROR: "{line} 行目に構文エラーがあります：{message}",
        VALIDATION_OVER_LIMIT: "スクリプトが 5,000 文字の制限を超えています（{n} 文字）。",
        VALIDATION_SERVICE_UNAVAILABLE: "検証サービスは一時的に利用できません。後でもう一度お試しください。",
        VALIDATION_UNDECLARED_VARIABLE: "スクリプトで未宣言の変数が使用されています：{vars}。入力フィールドが名称変更された場合は、スクリプト内の変数名を更新してください。",
        EXECUTION_ERROR_TIMEOUT: "実行がタイムアウトしました。",
        EXECUTION_ERROR_NO_RESULT: "スクリプトが結果を生成しませんでした。",
        EXECUTION_ERROR_SESSION_FAILURE: "実行セッションの開始に失敗しました。",
        EXECUTION_ERROR_TYPE_MISMATCH: "Result は有効な数値ではありません。",
        EXECUTION_ERROR_SESSION_UNAVAILABLE: "実行セッションが一時的に利用できません。しばらくしてから再試行してください。",
        WEB_SEARCH_HINT: "Bing の検索結果が自動的にコンテキストに注入されます。[[フィールドの説明]] を使って入力フィールドの値を参照できます。",
        WEB_SEARCH_TOOL: "Web Search Tool",
        WEB_SEARCH_ERROR_API: "ウェブ検索サービスが利用できません。しばらくしてからもう一度お試しください。",
        WEB_SEARCH_ERROR_QUOTA: "検索サービスは一時的に利用できません。しばらくしてからもう一度お試しください。",
        WEB_SEARCH_ERROR_SAVE: "検索結果の保存に失敗しました。",
        WEB_SEARCH_ERROR_TIMEOUT: "実行がタイムアウトしました。",
        PROVIDER_UNREACHABLE_ERROR: "AIサービスに接続できません。しばらくしてから再試行するか、管理者にお問い合わせください。",
        PROVIDER_AUTH_FAILED_ERROR: "AIサービスの認証に失敗しました。APIキーの設定を確認してください。",
        STRUCTURED_OUTPUT_PARSE_ERROR: "AI出力形式の解析に失敗しました。もう一度お試しください。",
        DOCUMENT_OUTPUT_ERROR_SYNTAX: "テンプレートの構文エラーです。Word テンプレートのタグ形式を確認してください。",
        DOCUMENT_OUTPUT_ERROR_MISMATCH: "テンプレートが現在の Agent データ構造と一致しません。フィールド名を確認してください。",
        DOCUMENT_OUTPUT_ERROR_RENDER: "ドキュメントの生成に失敗しました。テンプレートの形式が正しいか確認してください。",
        PDF_AS_IMAGE: "PDFを画像として解析",
        PDF_AS_IMAGE_HINT: "PDFの各ページを画像に変換してAIが判読します。PDFファイルにのみ適用されます。",
        IMAGE_ERROR_PDF_PAGES_EXCEEDED: "PDFの内容が画像数の上限を超えています ({n}>{x})",
        IMAGE_ERROR_INPUT_IMAGES_EXCEEDED: "参照する画像の数 {n} が画像数の上限 {x} を超えています",
        IMAGE_ERROR_MODEL_UNSUPPORTED: "選択したモデル {x} は画像入力に対応していません",
        INPUT_FILE_ERROR: "入力フィールド「{x}」の処理に失敗しました。修正してから再実行してください。",
        INPUT_PDF_NOT_READY: "入力フィールド「{x}」のPDFは現在の設定で再処理されていません。先にそのファイルフィールドを実行してください。",
    },
    //Up Portal
    MenuBarPortal: {
        NEW_THREAD: '新しい質問',
        LIBRARY: 'ライブラリ',
        THREAD_HISTORY: 'ログ',
    },
    MAIN_PORTAL_VIEW: {
        INTRO: '何かお手伝いできることはありますか？',
    },
    PORTAL: {
        SHARE: '共有',
        REFERENCE: '参考',
        ANSWER: '回答',
        KNOWLEDGE: '知識ベース',
        APPLY: '確認',
        Related: '関連トピック',
        RelatedImages: '関連画像',
        ViewLess: 'もっと少なく表示',
        ViewMore: 'もっと見る',
        ERROR_1: 'AIサーバーが混み合っています。後でもう一度お試しください。',
        ERROR_2: 'AI生成中です。少し待ってから再読み込みしてください。',
        MISS_CONTENT_TITLE: "参考資料が見つかりません。",
        MISS_CONTENT_DETAIL: "お探しのリソースは削除された可能性があります。",
        NO_RELATED_ANSWER: "現在、関連情報はありません!",
        ANSWER_INTERRUPTED: "この回答は完了していません。「再生成」をクリックして再度お試しください。",
        HELPFUL: "役に立つ",
        UNHELPFUL: "役に立たない",
        COPY: 'コピー',
        REWRITE: '再生成',
        DELETE_AGENT_CONFIRM: 'この操作により {agent} が削除されます。削除してもよろしいですか？',
        DELETE_COLUMN_CONFIRM: '{column} 列を削除します。削除してもよろしいですか？',
        DONT_DELETE: '削除しない',
        CONFIRM_UPDATE: '更新を確認',
        CONFIRM_DELETE: '削除を確認',
        ERROR_3: 'おっと、問題が発生しました。下の「再生成」ボタンを押してもう一度お試しください！',
        MY_KNOWLEDGE: '私のナレッジベース',
        THINKING_GENERATE: '推論',
        NO_REFERENCE: '参考資料がないため',
        MORE_RISK: "以下の回答には高いリスクがあります",
        NO_REFERENCE_MESSAGE: '今回の回答には参照資料が添付されていません。AI の回答が不正確な場合があります。ナレッジベースの内容を充実させるか、より完全で明確な指示・質問内容を入力することで、回答品質の向上が期待できます。(もしファイルをアップロードする場合は、「私がアップロードした文書に基づいて」と付けてから質問してください。)',
        WEB_SOURCE: "ソース：",
        ERROR_4: "接続が切断されました。ページを再読み込みしてください。",
        DELETE_ROWS_CONFIRM_MESSAGE: "この操作により、{tableName} のデータ {count} 件および下位階層の関連レコードが削除されます。削除してもよろしいですか？",
        FAVORITES: 'お気に入り知識ベース',
        FAVORITE_SHORT: 'お気に入り',
        ADD_TOOL_KNOWLEDGE: 'ツールと知識ベースを追加',
    },
    TENANTCENTER: {
        TITLE: 'Tenant Center',
        TENANTLIST: 'テナントリスト',
        USAGE_ANALYSIS: 'データセンター',
        CREATE_TENANT: '新しいテナントを追加する',
        CREATE_SUPERUSER: '新しいスーパーユーザーを追加する',
        UPDATE_SUBSCRIPTION: '有効期限を更新',
        LOGOUT: 'ログアウト',
        CREATE: '作成する',
    },
    TENANTCENTER_SUMMARY: {
        MONTH_USAGE: '月使用量',
        RANK_TABLE_HEADER_1: 'ストレージ使用量(G)',
        RANK_TABLE_HEADER_2: 'スマートドキュメント処理使用量(ページ)',
        RANK_TABLE_HEADER_3: 'スマートドキュメント処理容量(ページ)',
        RANK_TABLE_HEADER_4: '画像ストレージ使用量(枚)',
        RANK_TABLE_HEADER_5: '画像ストレージ容量(枚)',
        RANK_TABLE_HEADER_6: '残高(USD)',
        RANK_TABLE_HEADER_7: 'チャージ金額(USD)',
    },
    TENANTCENTER_TENANT_LIST: {
        SCHEMANAME: 'スキーマ名',
        TENANTNAME: 'テナント名',
        DESCRIPTION: '説明',
        CREATED_ON: '作成日',
        EXPIRATION: '有効期限',
        LICENSED: '承認数',
        ACTION: 'アクション',
    },
    ADD_TENANT: {
        TITLE: 'テナントを追加',
        TENANTNAME: 'テナント名',
        DESCRIPTION: '説明する',
        LICENSED: '承認数',
        NAME_HINT: '名前は繰り返すことはできず、テナントの作成後は変更できません。',
        LICENSED_HINT: 'テナントの確立後に追加できる新規ユーザーの数。',
        ADD_TENANT_WAIT: 'テナントの作成が進行中です。しばらく時間がかかる場合があります。後で「更新」をクリックすると、作成が完了したことを確認できます。',
        PROCESSING: '建物、お待ちください'
    },
    TENANTCENTER_USER_LIST: {
        LIST: 'ユーザーリスト',
        USERNAME: 'ユーザー名',
        FIRSTNAME: '名',
        LASTNAME: '姓',
        EMAIL: 'メール',
        SUPERUSER: 'スーパーユーザー',
        ADMIN: '管理者',
        ACTIVE: 'アクティブ',
        LOGIN_DATE: '最終ログイン',
        JOIN_DATE: '入社日',
    },
    ADD_SUPERUSER: {
        TITLE: 'スーパー管理者を追加',
        TENANTNAME: 'テナント名',
        SELECT_TENANT: 'テナントを選択',
        LASTNAME: '苗字',
        FIRSTNAME: '名',
        USERNAME: 'ユーザー名',
        EMAIL: 'メールアドレス',
        PASSWORD: 'パスワード',
        PASSWORD__HINT: 'パスワードには少なくとも 8 文字、少なくとも 1 つの大文字 (A ～ Z)、少なくとも 1 つの数字 (0 ～ 9)、少なくとも 1 つの特殊文字が含まれている必要があります。',
    },
    TENANT_PIPELINE: {
        CREATE: '作成',
        BUTTON: 'フローでテナントを設定',
        TITLE: 'フローでテナントを設定',
        STAGE_TENANT: 'テナント選択',
        STAGE_ADMIN: 'システム管理者',
        STAGE_UPCHAT: 'UpChat 有効化',
        STAGE_PORTAL: 'UpGPT Portal 有効化',
        STAGE_WORK_AGENT: 'Work Agent 有効化',
        STAGE_UPAGENT: 'UpAgent 有効化',
        CURRENT_TENANT: '設定中のテナント',
        PREVIOUS: '戻る',
        NEXT: '次へ',
        UPDATE: '更新',
        FINISH: '終了',
        UPDATING: '更新中...',
        FORM_INVALID: '入力内容を修正してから送信してください',
        PARTIAL_FAILED: '一部の項目が完了していません。下のメッセージを確認してください',
        MODE_EXISTING: '既存のテナント',
        MODE_NEW: '新規テナント',
        TENANT_EXISTS: 'テナント名は既に存在します',
        CREATING_TENANT: 'テナントを作成中...',
        LOADING_SEED: '基本データを読み込み中...',
        SEED_FAILED: 'テナントは作成されましたが、基本データの読み込みに失敗しました。作成ボタンを押して再試行してください。',
        SEED_RETRY_HINT: 'テナントは作成済みです。作成ボタンを押すと基本データの読み込みのみ再試行します。',
        ADMIN: '管理者',
        ADD_ADMIN: '管理者を追加',
        GENERATE_PASSWORD: '生成',
        CREATING_ACCOUNT: 'アカウントを作成中...',
        ADMIN_CREATED: '作成済み',
        ADMIN_PARTIAL_FAILED: '{total} 件中 {failed} 件の作成に失敗しました。修正して再度作成ボタンを押してください',
        NAME: '氏名',
        UPCHAT_USER: 'UpChat アカウント',
        UPCHAT_ACCOUNT: 'UpChat Account',
        CREATED: '作成済み',
        NOT_CREATED: '未作成',
        NO_SUPERUSER: 'このテナントにはシステム管理者がいません',
        ENABLE_PORTAL_KNOWLEDGE: 'UpGPT Portal ナレッジベースを有効化',
        ENABLE_IMAGE_SEARCH: '画像検索を有効化',
        STORAGE_SIZE: 'ナレッジストレージ上限（GB）',
        IMAGE_SEARCH_STORE: '画像検索の画像数上限（枚）',
        SEARCH_SERVICE: 'Search service',
        FROM_PREFERENCE: 'テナント {tenant} の設定から',
        UNREACHABLE: '接続不可',
        ORPHAN_INDEX: 'どのテナントにも対応しません',
        PORTAL_BOT_SOURCE: 'UpGPT Portal AI Bot のコピー元テナント',
        PORTAL_BOT_EXISTS: 'このテナントには UpGPT Portal AI Bot が既にあります：{name}',
        NO_PORTAL_BOT_SOURCE: 'コピーできる UpGPT Portal AI Bot を持つテナントがありません',
        ENABLE_WORK_AGENT: 'Work Agent を有効化',
        MAX_THREAD: 'Work Agent multi-thread 上限',
        WORK_AGENT_DISABLE_HINT: '更新するとこのテナントの Work Agent は無効になります。上限とモデル一覧は保持されます。',
        ENABLE_UPAGENT: 'UpAgent を有効化',
        ACTIVATION_CODE: 'アクティベーションコード',
        COPY: 'コピー',
        UPAGENT_DISABLE_HINT: '更新するとアクティベーションコードが削除され、UpAgent を有効化できなくなります。モデル一覧は保持されます。',
        INCLUDE_NATIVE_AOAI: 'ネイティブ AOAI モデルを含める',
        DISPLAY_NAME: '表示名',
        KEY_LOCKED: '既存モデルの key は変更できません',
        KEY_DUPLICATED: 'key が重複しています',
        COST_KEY_HINT: '未選択の場合は課金しません',
        DEFAULT_MODEL: 'デフォルトモデル',
        DEFAULT_MODEL_HINT: '未選択の場合は一覧の最初のモデル',
    },
    //Other
    BUSINESS_TYPE: {
        OPPTY: "商機",
        CASE: "案件",
        COMPANY: "会社",
        CONTACT: "担当者",
        AI_NOTEBOOK: "AIノートブック",
    },
    WIADVANCE: {
        MESSAGE_1: "少なくとも1つの製品を入力し、必須項目（Business Type、Customer Code、金額、予想粗利益、利益%）を確認してください。",
        MESSAGE_2: "選択した商機に少なくとも1つの製品が入力されていることと、必須項目（Business Type、Customer Code、金額、予想粗利益、利益%）が確認されていることをお願いします。",
    },
    FLEXFIELD: {
        SELECT_TABLE: "テーブル名"
    },
    ENTRAIDSYNC: {
        TITLE: "Entra ID 同期",
        INSTRUCTION: "同期するユーザーを選択してください。",
        SELECTED: "選択済み",
        EMAIL: "メール",
        FIRST_NAME: "名",
        LAST_NAME: "姓",
        SYNC: "同期されていますか",
        BUSINESS_PHONES: "内線電話",
        OFFICE_LOCATION: "オフィス所在地",
        JOB_TITLE: "職位",
        PORTAL_USER: 'ポータルユーザー',
    },
    LOGIN_PAGE_SETTING: {
        TITLE: "カスタム設定",
        SECTION_TITLE: "ログインページ設定",
        SAVE: "確認",
        SAVE_SUCCESS: "保存しました",
        SAVE_ERROR: "保存に失敗しました。しばらくしてから再試行してください",
        LOGO_IMAGE: "会社ロゴ",
        LOGO_HINT: "推奨サイズ: 360×80px、形式: png",
        BG_IMAGE: "背景画像",
        BG_HINT: "推奨サイズ: 1440×900、形式: jpg",
        TITLE_TEXT: "タイトルテキスト",
        TITLE_TEXT_PLACEHOLDER: "ようこそ",
        TITLE_TEXT_HINT: "20文字以内（漢字・ひらがな約10文字）",
        TITLE_COLOR: "タイトルの色",
        SUBTITLE_TEXT: "サブタイトルテキスト",
        SUBTITLE_TEXT_PLACEHOLDER: "UpGPT との素晴らしい会話を始めましょう",
        SUBTITLE_TEXT_HINT: "50文字以内（漢字・ひらがな約10〜25文字）",
        SUBTITLE_COLOR: "サブタイトルの色",
        LOGIN_BUTTON: "ログインボタン",
        BUTTON_COLOR: "ボタンの色",
        BUTTON_TEXT_COLOR: "テキストの色",
        COLOR_UNSET: "未設定",
        LOGIN_URL_LABEL: "ログイン URL",
        LOGIN_URL_DESC: "この URL でログインページにアクセスすると、ブランドのカスタマイズが適用されます",
        PORTAL_URL_LABEL: "UpGPT Portal",
        CONSOLE_URL_LABEL: "UpGPT Console",
        COPY: "コピー",
        COPY_SUCCESS: "コピーしました",
        IMG_FORMAT_ERROR_LOGO: "ロゴの形式が正しくありません。PNG 形式でアップロードしてください",
        IMG_FORMAT_ERROR_BG: "背景画像の形式が正しくありません。JPG 形式でアップロードしてください",
        IMG_SIZE_ERROR: "画像サイズが 5MB を超えています。別のファイルを選択してください",
    },
    URBANRENEWAL_ADMIN: {
        SYSTEM_TITLE: "都市再開発選択システム — 管理画面",
        PG: {
            TOTAL: '全 {count} 件',
            RPP: '{n} 件/ページ',
        },
        CURRENT_PROJECT: "現在のプロジェクト",
        PROJECT_LABEL: "プロジェクト名",
        NO_PROJECTS: "プロジェクトなし",
        NAV_BASIC: "基本情報",
        NAV_STATISTICS: "統計データ",
        NAV_HEATMAP: "選択状況",
        NAV_SIMULATION: "シミュレーション",
        NAV_MANUAL: "手動入力",
        PROJECT_SETTINGS: "プロジェクト設定",
        ADMIN_SETTINGS: "管理者設定",
        LOGOUT: "ログアウト",
        GEAR_MENU: "設定メニュー",
        LOGIN: {
            WELCOME: 'おかえりなさい',
            TITLE: 'ログイン',
            ACCOUNT: 'アカウント',
            PASSWORD: 'パスワード',
            SUBMIT: 'ログイン',
            FORGOT: 'パスワードをお忘れですか',
            ERR_REQUIRED: 'アカウントとパスワードを入力してください',
            ERR_INVALID: 'アカウントまたはパスワードが正しくありません',
            ERR_NO_ACCESS: '管理画面へのアクセス権限がありません',
            ERR_NO_TENANT: 'テナントを識別できません。ログインURLをご確認ください',
            COPYRIGHT: 'ART Solutions All Rights Reserved.',
        },
        PROJECT: {
            TITLE: '案件設定',
            ADD: '案件を追加',
            NAME: '案件名',
            START: '選択開始日',
            DEADLINE: '選択終了日',
            SAVE: '保存',
            SAVED: '保存しました',
            DELETE: '削除',
            EXPIRED: '終了',
            NAME_REQUIRED: '案件名を入力してください',
            DELETE_CONFIRM: '案件「{name}」を削除しますか？この操作は取り消せません。',
            DELETE_HAS_DATA: '関連データがあるため削除できません。',
            CANCEL: 'キャンセル',
            CLOSE: '閉じる',
            BACK: '戻る',
            SAVE_FAILED: '保存に失敗しました。再試行してください。',
        },
        PERIOD_LABEL: '選択期間',
        NO_PERIOD: '選択期間が未設定',
        LANDOWNER: {
            TAB_LANDOWNER: '地主データ',
            TAB_HOUSING: '住宅データ',
            TAB_PARKING: '駐車場データ',
            WIP: '開発中',
            PRIORITY_ZONE: '優先選択区',
            NAME: '所有権者',
            ACCOUNT: 'アカウント',
            PASSWORD: 'パスワード',
            ADDRESS: '建物住所',
            LAND_SHARE: '土地持份',
            PARKING_ALLOCATION: '駐車場割当',
            PARKING_VALUE: '駐車場価値（円）',
            PRE_RATIO: '更新前権利割合（%）',
            PRE_VALUE: '更新前価値（円）',
            SELECTABLE_VALUE: '選択可能価値（円）',
            ALLOCATED_VALUE: '配分価値（円）',
            ACTION: '操作',
            IMPORT: 'Excel インポート',
            EXPORT: 'Excel エクスポート',
            DELETE: '削除',
            DELETE_N: '{count} 件を削除',
            REGEN_PASSWORD: 'パスワード再生成',
            COPY: 'コピー',
            COPIED: 'コピーしました',
            DELETE_CONFIRM: '選択した {count} 件の地主を削除しますか？この操作は取り消せません。',
            DELETE_CONFIRM_ROWS: '選択した {count} 件を削除しますか？この操作は取り消せません。',
            CANCEL: 'キャンセル',
            CLOSE: '閉じる',
            CONFIRM: '確認',
            REGEN_TITLE: '新しいパスワード',
            REGEN_HINT: 'コピーして地主にお伝えください（自動送信はされません）。',
            IMPORT_ERROR_TITLE: 'インポート結果',
            IMPORT_SUMMARY: 'インポート完了：新規 {created} 件・更新 {updated} 件。以下の行はスキップされました：',
            IMPORT_SUCCESS: 'インポート完了：新規 {created} 件・更新 {updated} 件、エラーなし。',
            COL_ROW: '行番号',
            COL_REASON: 'エラー内容',
            IMPORT_FAILED: 'インポートに失敗しました。ファイル形式をご確認ください。',
            SAVE_FAILED: '保存に失敗しました。再試行してください。',
            TOTAL: '{count} 件',
            RPP: '表示件数',
            NO_DATA: 'データなし',
            SELECT_PROJECT: 'プロジェクトを選択してください',
            LOADING: '読み込み中...',
        },
        HOUSING: {
            PRIORITY_ZONE: '優先選択区',
            CODE: '住戸番号',
            AREA: '権利面積(坪)',
            UNIT_PRICE: '単価(円/坪)',
            TOTAL_PRICE: '総額(円)',
            SALES_UNIT_PRICE: '販売単価(円)',
            SALES_TOTAL_PRICE: '販売総額(円)',
        },
        PARKING: {
            CODE: '駐車場番号',
            SPEC: '仕様',
            TYPE: '形式',
            VALUE: '価値(円)',
        },
        STAT: {
            TAB_LANDOWNER: '土地所有者統計',
            TAB_HOUSING: '住戸統計',
            TAB_PARKING: '駐車場統計',
            WIP: '開発中',
            FILTER_ZONE: '優先選択区',
            FILTER_NAME: '所有者を検索',
            FILTER_STATUS: '選択状況',
            ALL: 'すべて',
            COUNT: '{count} 組の土地所有者',
            COL_ZONE: '優先選択区',
            COL_OWNER: '所有者',
            COL_HOUSE: '選択住戸番号',
            COL_PARKING: '選択駐車場番号',
            COL_SELECTION_TOTAL: '選択合計金額(元)',
            COL_MAKEUP: '補填予定金額(元)',
            COL_MAKEUP_STATUS: '補填状態',
            COL_SELECTION_STATUS: '選択状況',
            COL_OVER_RATIO: '超過選択率',
            SEL_LOW: '不足選択',
            SEL_NORMAL: '通常',
            SEL_OVER: '超過選択',
            MK_REFUND: '返金可能',
            MK_PAY: '追加支払い',
            DASH: '—',
            EXPORT: 'Excel エクスポート',
            NO_DATA: 'データなし',
            SELECT_PROJECT: 'プロジェクトを選択してください',
            LOAD_FAILED: '読み込み失敗',
            EXPORT_FAILED: '出力失敗',
            SEARCH_HOUSE: '住戸番号を検索',
            SEARCH_PARKING: '駐車場番号を検索',
            FILTER_CATEGORY: '選択区分',
            CAT_NORMAL: '正常',
            CAT_NONPRIORITY: '非優先',
            CAT_OVER: '超過',
            HS_COL_ZONE: '優先選択区',
            HS_COL_CODE: '住戸番号',
            HS_COL_NORMAL: '正常選択',
            HS_COL_NONPRIORITY: '非優先選択',
            HS_COL_OVER: '超過選択',
            PS_COL_CODE: '駐車場番号',
            PS_COL_NORMAL: '正常選択',
            PS_COL_OVER: '超過選択',
            COL_GROUP_COUNT: '組数集計',
            UNIT_GROUP: '組',
            COUNT_ROWS: '{count} 件',
        },
        HEATMAP: {
            TAB_HOUSING: '住戸選択',
            TAB_PARKING: '駐車場選択',
            WIP: '開発中',
            EXPORT_PDF: 'PDF 出力',
            EXPORT_EXCEL: 'Excel 出力',
            EXPORT_FAILED: 'エクスポートに失敗しました。しばらくしてからお試しください。',
            PDF_TITLE: '住戸選択ヒートマップ',
            PDF_FAILED: 'PDF 出力に失敗しました。ポップアップを許可して再試行してください',
            TT_UNIT_CODE: 'ユニット番号',
            TT_AREA: '面積',
            TT_UNIT_PRICE: '単価（元/坪）',
            TT_TOTAL_PRICE: '総額（元）',
            TT_SPEC: '仕様',
            TT_TYPE: 'タイプ',
            TT_VALUE: '価値',
            TT_COUNT: '選択組数',
            TT_OWNERS: '地主',
            TT_NORMAL: '通常',
            TT_NONPRIORITY: '非優先',
            TT_OVER: '超過選択',
            U_PING: '坪',
            U_YUAN: '元',
            UNIT_GROUP: '組',
            LGD_NONE: '0組選択',
            LGD_ONE: '1 組選択',
            LGD_MULTI: '複数選択',
            LOAD_FAILED: '読み込み失敗',
            NO_DATA: 'データなし',
            SELECT_PROJECT: '先に案件を選択してください',
            PDF_TITLE_PARKING: '駐車場選択ヒートマップ',
            TT_CODE: '駐車場番号',
        },
        SIM: {
            OWNER_SECTION: '地主情報',
            SELECT_SECTION: '住戸・駐車場選択',
            RESULT_BASIC: '基本情報',
            RESULT_SELECTION: '選択シミュレーション',
            OWNER_NAME: '地主氏名',
            HOUSE_CODE: '住戸番号',
            PARKING_CODE: '駐車場番号',
            ALLOCATED: '配分価値',
            SELECTABLE: '選択可能価値',
            SELECTION_TOTAL: '選択合計',
            SELECTION_RATIO: '選択比率',
            MAKEUP: '概算補填金額',
            ADD_OWNER: '地主を追加',
            ADD_HOUSE: '住戸を追加',
            ADD_PARKING: '駐車場を追加',
            CALC: 'シミュレーション',
            RESET: 'リセット',
            RESULT_TITLE: 'シミュレーション結果',
            REFUND: '差額返還可',
            PAY: '差額支払い要',
            CANNOT_CALC: '計算不可',
            CLEAR_ALL: 'すべてクリア',
            NAME_HEADER: '氏名',
            COL_UNIT_CODE: '選択ユニット番号',
            COL_DUP_GROUP: '重複組数',
            HOUSE_ITEM: '住戸',
            PARK_ITEM: '駐車場',
            FORMULA_CASE_A: '合計 ≤ 配分×110%（{threshold}元）',
            FORMULA_CASE_B: '合計 > 配分×110%（{threshold}元）',
            BALANCE_DEFICIT: '不足差額',
            PH_OWNER: '地主を選択',
            PH_HOUSE: '住戸を選択',
            PH_PARKING: '駐車場を選択',
            SEARCH_PH: '検索…',
            NO_RESULT: '該当なし',
            OWNER_ITEM: '地主',
            GROUP_UNIT: '組',
            LOAD_FAILED: '読み込み失敗',
            SELECT_PROJECT: '先に案件を選択してください',
            HINT_CALC: '左側で地主と住戸／駐車場を選択し「試算」をクリックしてください',
        },
        MANUAL: {
            OWNER: '所有者',
            HOUSE: '選択住戸',
            PARKING: '選択駐車場',
            GRP_COL: '組',
            SUB_OWNER: '人',
            SUB_HOUSE: '選房',
            SUB_PARK: '選車',
            DELETE_COL: '列を削除',
            ACTION: '操作',
            SORT_LABEL: '並び替え',
            SORT_NONE: '並び替えなし',
            SORT_NAME: '所有権者順',
            SORT_ZONE: '優先選択区順',
            IMPORT: 'Excel インポート',
            EXPORT: 'Excel エクスポート',
            SAVE: '保存',
            ADD_ROW: '行を追加',
            ADD_COL: '＋ {name}列',
            DELETE: '削除',
            CHANGELOG: '変更履歴',
            CHANGELOG_EMPTY: '変更履歴はまだありません',
            CLOSE: '閉じる',
            OP_ADD: '追加',
            OP_DELETE: '削除',
            SAVE_SUCCESS: '保存しました',
            SAVE_WARN: '保存しました。ただし存在しない番号 {count} 件はスキップされました',
            SAVE_FAILED: '保存に失敗しました。再試行してください。',
            IMPORT_FAILED: 'インポートに失敗しました。ファイル形式を確認してください。',
            EXPORT_FAILED: 'エクスポートに失敗しました。しばらくしてからお試しください。',
            IMPORT_ERROR_TITLE: 'インポート失敗',
            IMPORT_WARN_TITLE: 'インポート完了（一部スキップ）',
            IMPORT_WARN_INTRO: 'インポート完了。以下は識別できずスキップされました（画面のドロップダウンで追加してください）:',
            NO_DATA: 'データがありません。行を追加するかインポートしてください。',
            SELECT_PROJECT: '先に案件を選択してください',
            LOAD_FAILED: '読み込み失敗',
        },
        BRANDING_TITLE: 'ブランドロゴ',
        UPLOAD_LOGO: 'ロゴをアップロード',
        REMOVE_LOGO: 'ロゴを削除',
        LOGO_UPLOADED: 'ロゴが更新されました',
        LOGO_REMOVED: 'ロゴが削除されました',
        LOGO_UPLOAD_FAILED: 'ロゴのアップロードに失敗しました。再度お試しください',
        LOGO_INVALID_TYPE: '画像ファイルのみアップロード可能です（png / jpg / gif / webp など）',
        LOGO_HINT: '透明背景の PNG を推奨',
        AI_SUPPORT: {
            TITLE: 'AIカスタマーサポート設定',
            ENABLE: 'AIサポートを有効化',
            URL: 'サービスURL',
            URL_PH: '例：https://chat.upday.ai',
            TOKEN: 'Website Token',
            TOKEN_PH: 'UpChat ウェブチャットの websiteToken を貼り付け',
            SAVE: '保存',
            SAVED: '保存しました',
            SAVE_FAILED: '保存に失敗しました。再試行してください',
        },
        ADMINS: {
            TITLE: '管理者設定',
            ADD: '管理者を追加',
            COL_EMAIL: 'Email',
            COL_LAST_NAME: '姓',
            COL_FIRST_NAME: '名',
            COL_STATUS: 'ステータス',
            COL_LAST_LOGIN: '最終ログイン',
            STATUS_ACTIVE: '有効',
            STATUS_INACTIVE: '無効',
            SAVE: '保存',
            DELETE: '無効化',
            REACTIVATE: '再有効化',
            DELETE_CONFIRM: '管理者「{name}」を無効化しますか？バックエンドへのアクセスが停止されます。',
            CREATED: '管理者を作成し招待メールを送信しました',
            REACTIVATED: '管理者を再有効化しました',
            SAVED: '保存しました',
            EMAIL_REQUIRED: '有効な Email を入力してください',
            EMAIL_DUP: 'この Email はすでに管理者です。無効化されている場合は再有効化を使用してください。',
            SAVE_FAILED: '操作に失敗しました。再度お試しください',
            LOAD_FAILED: '読み込み失敗',
            CANCEL: 'キャンセル',
            CLOSE: '閉じる',
            CONFIRM: '確認',
            NO_DATA: '管理者はまだいません',
            EDIT: '編集',
            BACK: '戻る',
            ACCOUNT: 'アカウント',
            PH_LAST: '姓を入力',
            PH_FIRST: '名を入力',
            PH_EMAIL: 'name@company.com',
        },
    },
    URBANRENEWAL_SELECT: {
        LOGIN: {
            WELCOME: '都市再開発 住宅・駐車場選択システム',
            SYS_DESC: '配布されたアカウントでログインし、住宅・駐車場の選択と試算を行ってください。',
            TITLE: 'ログイン',
            ACCOUNT: 'アカウント',
            PASSWORD: 'パスワード',
            SUBMIT: 'ログイン',
            FORGOT: 'パスワードをお忘れですか',
            ERR_REQUIRED: 'アカウントとパスワードを入力してください',
            ERR_INVALID: 'アカウントまたはパスワードが正しくありません',
            ERR_NO_TENANT: 'テナントを識別できません。ログインURLをご確認ください',
            COPYRIGHT: 'ART Solutions All Rights Reserved.',
        },
        FORGOT: {
            TITLE: 'パスワードをお忘れの方',
            DESC: 'アカウント（Eメール）を入力してください。パスワード再設定用のリンクをお送りします。',
            ACCOUNT: 'アカウント（Eメール）',
            SUBMIT: '再設定リンクを送信',
            DONE: 'アカウントが存在する場合、パスワード再設定用のリンクをメールに送信しました。',
            BACK_LOGIN: 'ログインに戻る',
            ERR_REQUIRED: 'アカウントを入力してください',
        },
        RESET: {
            TITLE: 'パスワードの再設定',
            NEW_PWD: '新しいパスワード',
            CONFIRM_PWD: '新しいパスワード（確認）',
            SUBMIT: '再設定を確定',
            SUCCESS: 'パスワードを再設定しました。新しいパスワードでログインしてください。',
            ERR_REQUIRED: '新しいパスワードを入力してください',
            ERR_MISMATCH: '入力したパスワードが一致しません',
            ERR_INVALID: 'リンクが無効または期限切れです。再度申請してください。',
            BACK_LOGIN: 'ログインに戻る',
        },
        LAYOUT: {
            SYSTEM_TITLE: '都市再開発 住宅・駐車場選択システム',
            LOGOUT: 'ログアウト',
        },
        STATUS: {
            DRAFT: '選択試算中',
            SUBMITTED: '保存済み',
            LOCKED: '締切済み',
        },
        PERIOD_LABEL: '選択期間',
        LAST_UPDATED: '最終更新時刻',
        STATS_UPDATED: '本統計結果の最終更新時刻',
        PANEL: {
            INTRO_LINE1: '{deadline} までに住宅・駐車場の選択資料の入力を完了してください。',
            INTRO_LINE2: '締切日前はいつでも修正できますが、締切を過ぎると一切変更できません。',
            BASIC_INFO: '基本情報',
            OWNER_LABEL: '地主{no}：',
            OWNER: '地権者',
            ALLOCATED: '配分価値：',
            SELECTABLE: '選択可能価値：',
            CURRENCY_UNIT: '元',
            SELECTION_LIST: '選択試算',
            MOBILE_VIEW_GRID: '現在の選択状況',
            MOBILE_BACK: '試算表に戻る',
            HOUSE: '住宅選択',
            PARKING: '駐車場選択',
            AREA_PING: '坪数',
            UNIT_PRICE: '単価（元/坪）',
            TOTAL_PRICE: '総額（元）',
            SPEC: '規格',
            VALUE: '価値（元）',
            SELECTED_GROUPS: '選択済み {count} 組',
            COL_UNIT_CODE: 'フロア番号',
            COL_GROUP_COUNT: '重複組数',
            HOUSE_ROW: '住宅{no}：',
            PARKING_ROW: '駐車場{no}：',
            ADD_HOUSE: '住宅を追加',
            ADD_PARKING: '駐車場を追加',
            SEARCH: '検索…',
            NO_OPTIONS: '選択できる項目がありません',
            UNIT_PH_HOUSE: '住宅番号を選択',
            UNIT_PH_PARK: '駐車場番号を選択',
            SELECT_TOTAL: '選択価値合計：',
            MAKEUP_TITLE: '精算試算',
            MAKEUP_REFUND: '返金額：',
            MAKEUP_PAY: '追加支払額：',
            MAKEUP_NONE: '找補金額：',
            AMOUNT_NOTE: '※上記金額は参考用です。実際は権利変換の認定及び最終選択結果に基づきます。',
            DISCLAIMER: '本表は、現在提出済みの「更新後配分位置申請書」及び「合併配分協議書」の紙面原本のみに基づく暫定集計であり、最終的な選定結果ではありません。最終的な住宅・駐車場の選択結果は、公開抽選会議で公表される選択及び抽選結果によります。',
            CLEAR_ALL: 'すべてクリア',
            EXPORT: 'Excel エクスポート',
            SAVE: '保存してダウンロード',
            REMOVE: '削除',
            SAVE_SUCCESS: '選択結果を保存し、画像のダウンロードが完了しました。',
            SAVE_FAIL: '保存に失敗しました',
            EXPORT_FAIL: 'エクスポートに失敗しました',
            EXPORT_NEED_SAVE: '先に保存してからエクスポートしてください',
            EXPORT_DIRTY: '保存されていない変更があります。先に保存してからエクスポートしてください',
            EXPORT_FILENAME: '選択試算.xlsx',
        },
        GRID: {
            UNIT_GROUP: '組',
            LGD_NONE: '0組選択',
            LGD_ONE: '1組選択',
            LGD_MULTI: '複数組選択',
            LGD_NONPRIORITY: '非優先区',
            OVER_LIMIT_WARN: '現在選択されている住宅・駐車場の総額が配分価値の110%を超えています。選択し直してください。',
            NO_DATA: 'データがありません',
        },
        UNIT: {
            AREA_PING: '坪数',
            UNIT_PRICE: '単価（元/坪）',
            TOTAL_PRICE: '総額（元）',
            SPEC: '規格',
            VALUE: '価値（元）',
            SELECTED_GROUPS: '選択済み組数',
            LINE_AREA: '坪数：{v}坪',
            LINE_UNIT_PRICE: '単価（元/坪）：{v}元',
            LINE_TOTAL_PRICE: '総価（元）：{v}元',
            LINE_SPEC: '仕様：{v}',
            LINE_GROUPS: '選択済み組数：{v}組',
            ADD_SELECTION: '選択を追加',
            ALREADY_ADDED: 'このユニットを選択済み',
            CANCEL_SELECTION: 'この選択を取消',
            CLOSE: '閉じる',
            NONPRIORITY_WARN: 'ご注意：今回選択された住宅ユニットは、選択規則上、台端（お客様）の優先選択区に属していません。選択期間中に優先選択区の他の所有権者が同じ住宅ユニットを申請した場合、獲得できない可能性があります。選択の変更をご検討ください。ご不便をおかけして申し訳ございません。',
            NONPRIORITY_HINT: '本ユニットはお客様の優先選択区ではありません。優先選択区の地主の選択と重複した場合、抽選による選択ができません。',
        },
        OVER: {
            TITLE: '選択可能上限を超えています',
            CONFIRM: '確認',
        },
        DIALOG: {
            INTRO_TITLE: '選択試算に関するご注意',
            INTRO_PERIOD_LABEL: '現在の選択試算期間：',
            INTRO_PERIOD_RANGE: '{start} 〜 {end}',
            INTRO_BODY: '本システムの住宅・駐車場の選択及び找補金額は試算参考のみです。選択期間内に「更新後配分位置申請書」及び「合同配分協議書」等の正式な紙面原本を実施者へご提出いただき、お客様の権益を確保してください。',
            INTRO_OK: '了解しました',
            GRID_NOTICE: '本図表は、提出済みの「更新後配分位置申請書」及び「合併配分協議書」の紙面登録集計のみを表示します。今回の選択試算の結果は集計に計上されず、参考用です。',
            GRID_NEXT: '次へ',
            LEGEND_TITLE: '凡例の説明',
            LEGEND_ENTER: '選択へ進む',
            NONPRIORITY_TITLE: '非優先選択区に関するご注意',
            NONPRIORITY_CONFIRM: '確認',
            NONPRIORITY_RESELECT: '選び直す',
            SAVE_TITLE: '保存の確認',
            SAVE_BODY: '今回の住宅・駐車場の選択は参考用であり、正式な選択集計には計上されません。選択期間内に「更新後配分位置申請書」及び「合併配分協議書」等の紙面原本を実施者へご提出いただき、お客様の権益を確保してください。',
            SAVE_CONFIRM: '確定',
            SAVE_CANCEL: '前に戻る',
            RESULT_TITLE: '今回の選択結果',
            RESULT_TIME: '生成時間：{t}',
            RESULT_OWNER: '地権者',
            RESULT_HOUSE: '住宅',
            RESULT_PARK: '駐車場',
            RESULT_EMPTY: 'まだ選択されていません',
        },
        CHAT: {
            TITLE: 'AIアシスタント',
            COMING_SOON: 'AIアシスタントは近日公開予定です',
        },
    },
    LICENSE_WARNING: {
        EXPIRING_SOON: 'ライセンスは {date} に有効期限が切れます。更新については弊社営業担当までご連絡ください。',
        EXPIRED_GRACE: 'ライセンスは {date} に有効期限が切れました。至急、弊社営業担当までご連絡のうえ更新してください。サービスは {stopDate} に停止します。',
        SUSPENDED: 'ライセンスは {date} に有効期限が切れました。引き続きご利用いただくには、弊社営業担当までご連絡のうえ更新してください。',
        // 佔位文案：正式文案待需求方提供
        INVALID: 'ライセンス情報に問題があります。弊社営業担当までご連絡ください。',
        PREFIX_SUSPENDED: 'サービス停止',
        PREFIX_INVALID: 'ライセンス無効',
    },
}
